import { LEGAL_PATROCINADOR_CALIENTE, LEGAL_PATROCINADOR_CODERE } from "../constantes/constantes";

// Devuelve la fecha del sistema en formato YYYY-MM-DD
export function getSystemDay() {
  const now = new Date();

  // Obtiene el año, mes y día de la fecha actual
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0"); // El mes es de 0 a 11, se suma 1
  const day = now.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`
}

// Devuelve la hora en formato HH:mm (24 horas)
export function hourFormat(date) {
  const d = new Date(date);
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
}

// Utilidad interna: Capitaliza la primera letra
function capitalizeFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Devuelve fecha en formato "Mes Día", ej: "Abril 9"
export function dateFormat(date) {
  const d = new Date(date);
  const month = capitalizeFirst(d.toLocaleDateString('es-ES', { month: "long" }));
  const day = d.getDate();
  return `${month} ${day}`;
}

// Devuelve fecha en formato "Día Mes", ej: "9 Abril"
export function dateFormatInverse(date) {
  const d = new Date(date);
  const month = capitalizeFirst(d.toLocaleDateString('es-ES', { month: "long" }));
  const day = d.getDate();
  return `${day} ${month}`;
}

// Devuelve fecha corta en formato "9 abr"
export function dateFormatInverseShort(date) {
  const d = new Date(date);
  const month = d.toLocaleDateString('es-ES', { month: "short" }).toLowerCase();
  const day = d.getDate();
  return `${day} ${month}`;
}

// Devuelve la fecha en formato "Mes Día" (alias de dateFormat)
export function getLabelDate(date) {
  return dateFormat(date);
}

// obtiene la fecha y hora del sistema a partir de la hora de paris
export function getParisSystemDayParis() {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'Europe/Paris' };
  const date = new Date().toLocaleString('sv-SE', options).split(' ')[0];
  return date;
}

// Formatea fecha en formato "ABR 9 | 6:45 PM" (12 horas)
export function formatResultsDate12Hours(dateString) {
  const date = new Date(dateString);
  const month = date.toLocaleString('es-MX', { month: 'short' }).toUpperCase(); // ABR
  const day = date.getDate();
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // 0 -> 12
  const minuteStr = minutes.toString().padStart(2, '0'); // 8 -> 08

  return `${month} ${day} | ${hours}:${minuteStr} ${ampm}`;
}

// Formatea fecha en formato "ABR 9 | 18:45" (24 horas)
export function formatResultsDate(dateString) {
  const date = new Date(dateString);
  const month = date.toLocaleString('es-MX', { month: 'short' }).toUpperCase(); // ABR
  const day = date.getDate(); // 1 - 31

  let hours = date.getHours(); // 0 - 23 (ya en 24h)
  const minutes = date.getMinutes();
  const minuteStr = minutes.toString().padStart(2, '0'); // 8 -> 08
  const hourStr = hours.toString().padStart(2, '0'); // 9 -> 09

  return `${month} ${day} | ${hourStr}:${minuteStr}`; // Ejemplo: ABR 3 | 18:45
}

/**
 * Acción común para botones patrocinados en cards.
 * Abre la URL en una nueva pestaña sin propagar el evento.
 */
export function handleClickCard(e, url) {
  e.preventDefault();
  e.stopPropagation();
  if (url) window.open(url, '_blank');
};

/**
 * Retorna la clase final para el marcador dependiendo del estado del juego y el equipo.
 */
export const getScoreClass = (baseClass, teamClass, classGame) => {
  if (classGame === 'clarosports-error-game') return `${baseClass} score-error`;

  if (teamClass === 'clarosports-winner' && classGame !== 'clarosports-next-game' && classGame !== 'clarosports-error-game') {
    return classGame === 'clarosports-finished-game' ? `${baseClass} score-ganador-final` : `${baseClass} score-ganador`;
  }
  if (teamClass === 'clarosports-draw' && classGame === 'clarosports-finished-game') {
    return `${baseClass} score-empate`;
  }
  if (teamClass === 'clarosports-draw' && (classGame === 'clarosports-next-game' || classGame === 'clarosports-in-progress-game')) {
    return `${baseClass} score-empate`;
  }
  if (teamClass === 'clarosports-loser' || (classGame === 'clarosports-next-game' && teamClass === 'clarosports-winner')) {
    return `${baseClass} score-perdedor`;
  }

  return baseClass;
};

/**
 * Devuelve el texto legal correspondiente al patrocinador.
 * Si no se encuentra, retorna string vacío.
 */
export function getLegalTextBySponsor(patrocinador = '') {
  const legalTextMap = {
    codere: LEGAL_PATROCINADOR_CODERE,
    caliente: LEGAL_PATROCINADOR_CALIENTE,
    strendus: 'Permiso SEGOB DGG/SP/404/97. Diviértete responsablemente. Los juegos de apuestas están prohibidos para menores de edad.'
  };

  return legalTextMap[patrocinador?.trim().toLowerCase()] || '';
}

export const ENDPOINTS = {
  principales: "principales",
  automatico: "principales/principales_automatico",
  manual: "principales/principales_manual",
  semanal: "principales/principales_semanal",
  unotv: "principales_unotv"
};

export const openLink = (href, newTab = false) => {
  if (!href) return;
  if (newTab) window.open(href, "_parent", "noopener,noreferrer");
  else window.location.href = href;
};

export const openLinkParent = (href, newTab = false) => {
  if (!href) return;
  if (newTab) window.open(href, "_top", "noopener,noreferrer");
  else window.top.location.href = href;
};

export function parseDate(str) {
  const [day, month, year] = str.split("/").map(Number);
  return new Date(year, month - 1, day);
}

export function filterSportsByCode(data, sportCode) {
  if (!sportCode) return data;
  const filterOne = (day) => ({
    ...day,
    sports: Array.isArray(day?.sports) ? day.sports.filter(s => s?.sport_code === sportCode) : []
  });
  if (Array.isArray(data)) {
    return data.map(filterOne);
  }
  if (data && typeof data === 'object') {
    return filterOne(data);
  }
  return data;
}

export function formatId(leagueName) {
  return leagueName.replace(/-/g, "").replace(/ /g, "");
}

export const norm = (v) => String(v ?? "");

export const hasValidData = (l, r, lu, ru) =>
  norm(l).trim().length !== 0 &&
  norm(r).trim().length !== 0 &&
  norm(lu).trim().length !== 0 &&
  norm(ru).trim().length !== 0;

//-- funcion para dar formato a la hora
export const hourFormatHub = (time) => {
  let format = new Date(time);
  let hour = format.getHours();
  let minutes = format.getMinutes();
  hour = ("0" + hour).slice(-2);
  minutes = ("0" + minutes).slice(-2);

  return `${hour}:${minutes}`;
};

export async function fetchData(url) {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Error al obtener los datos. Código de estado: ${response.status}`);
  return response.json();
}

/**
 * Función utilitaria para manejar datos de apuestas y momios
 * Centraliza la validación de momios y URLs de apuestas según la casa de apuestas
 * 
 * @param {Object} item - Datos del evento deportivo
 * @param {Object} item.caliente_metadata - Datos de momios de Caliente
 * @param {Object} item.strendus_data - Datos de momios de Strendus
 * @param {boolean} isStrendus - Si usar Strendus como casa de apuestas
 * 
 * @returns {Object} Datos de apuestas procesados
 */
export function getBettingData(item, isStrendus) {
  const { caliente_metadata, strendus_data } = item;

  // Validación de momios según la casa de apuestas
  const hasMm = !isStrendus
    ? hasValidData(
      caliente_metadata?.left_mm,
      caliente_metadata?.right_mm,
      caliente_metadata?.left_url_mm,
      caliente_metadata?.right_url_mm
    )
    : hasValidData(
      strendus_data?.left_mm,
      strendus_data?.right_mm,
      strendus_data?.left_url_mm,
      strendus_data?.right_url_mm
    );

  // URL para el botón de apuestas
  const apostarHref = isStrendus
    ? strendus_data?.strendus_default_event
    : caliente_metadata?.url_mm_evento;

  return {
    hasMm,
    apostarHref,
    caliente_metadata,
    strendus_data
  };
}

/**
 * Función utilitaria para determinar los estados de un juego/evento deportivo
 * Centraliza la lógica de formateo de tiempo y determinación de estados
 * 
 * @param {Object} item - Datos del evento deportivo
 * @param {string} item.utc_date - Fecha UTC del evento
 * @param {string} item.class - Clase CSS que indica el estado del evento
 * 
 * @returns {Object} Estados del juego
 */
export function getGameStates(item) {
  const time_format = hourFormat(item.utc_date);
  const cls = String(item.class).toLowerCase();
  const isNextOrError = cls === "clarosports-next-game" || cls === "clarosports-error-game";
  const isFinished = cls === "clarosports-finished-game";
  const isError = cls === "clarosports-error-game";

  return {
    time_format,
    cls,
    isNextOrError,
    isFinished,
    isError
  };
}

/**
 * Configuración de columnas para diferentes tipos de tabla
 * Define qué campos mostrar y cómo etiquetarlos
 */
export const COLUMN_CONFIGS = {
  drivers: {
    fields: ['position', 'firstName', 'image', 'totalPoints'],
    labels: {
      position: 'Puesto',
      firstName: 'Piloto',
      image: 'Escudería',
      totalPoints: 'Puntos'
    },
    customRenders: {
      firstName: (item) => {
        const firstLetter = item.firstName ? item.firstName.charAt(0) : '';
        const name = `${firstLetter}. ${item.lastName || ''}`;
        const nationality = item.nationalityCode || item.nationality;
        return { name, nationality };
      },
      image: (item) => {
        return { teamImage: item.image };
      }
    }
  },
  teams: {
    fields: ['position', 'team', 'totalPoints'],
    labels: {
      position: 'Puesto',
      team: 'Equipo',
      totalPoints: 'Puntos',
    },
    customRenders: {
      team: (item) => {
        const teamName = item.team || item.name;
        const image = item.image;
        return { teamName, image };
      }
    }
  }
};

/**
 * Función utilitaria para generar datos del contenedor de liga
 * Centraliza la lógica de generación de IDs y clases para contenedores de liga
 * 
 * @param {Object} league - Datos de la liga
 * @param {string} league.name - Nombre de la liga
 * @param {number} indexLeague - Índice de la liga en el array
 * @param {Object} openMap - Mapa de visibilidad de ligas
 * 
 * @returns {Object} Datos del contenedor de liga
 */
export function getLeagueContainer(league, indexLeague, openMap) {
  const contId = String(league.name).replace(/-/g, "").trim().replace(/ /g, "");
  const id = formatId(league.name);
  const visible = !!openMap[id];

  return {
    contId,
    id,
    visible,
    key: contId || indexLeague
  };
}

// Función para determinar la clase condicional basada en la longitud de games
export const getGridClass = (gamesLength) => {
  if (gamesLength === 1 ) return 'grid-card-0';
  if (gamesLength === 2) return 'grid-card-1';
  if (gamesLength >= 3 ) return 'grid-card-2';
  return '';
};

// 👇 pega aquí tal cual tu arreglo:
export const F1_HARDCODED_GAMES = [
  {
    name: "Formula 1 ",
    sport_code: "MTR",
    print_momios: false,
    leagues: [
      {
        name: "Carrera 1 - Formula 1",
        order: 1,
        live_game_order: 1,
        games: [
          {
            "id_juego": "4pqm1uh51lj0u08uc04eaej8",
            "id_liga": "",
            "id_torneo": "",
            "game_name": "**Dutch Grand Prix / Friday practice",
            "class": "clarosports-in-progress-game",
            "phase": "",
            "right_name": "",
            "right_short_name": "",
            "left_name": "",
            "left_short_name": "",
            "left_image": "",
            "right_image": "",
            "period_title": "04:30",
            "score": "",
            "liga": "FIA F1 World Championship 2025",
            "order_league": 1,
            "date": "29 de Ago",
            "current": true,
            "left_class": "",
            "right_class": "",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-29T10:30:00Z",
            "should_print_time": true,
            "sport": "MTR",
            "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=9l7ordv5sqnck0498ityvh444&utm_id=4pqm1uh51lj0u08uc04eaej8&utm_campaign=home_liga_partido&utm_content=dutch_grand_prix",
            "venue_name": "Circuit Zandvoort",
            "venue_state": "Zandvoort",
            "venue_country": "Netherlands",
            "left_score": "",
            "right_score": "",
            "left_seed": "",
            "right_seed": "",
            "left_tenis_score": null,
            "right_tenis_score": null,
            "tenis_fase": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": [
                {
                  "firstName": "Lando",
                  "lastName": "Norris",
                  "points": "0.000",
                  "nationality": "",
                  "carNumber": 0,
                  "team": "McLaren",
                  "timeHours": 0,
                  "timeMinutes": 0,
                  "timeSeconds": 0,
                  "timeMilliseconds": 0,
                  "timeDiference": "+0.000s",
                  "timeString": "00:01:10.278",
                  "nationalityCode": "GBR"
                },
                {
                  "firstName": "Oscar",
                  "lastName": "Piastri",
                  "points": "0.000",
                  "nationality": "",
                  "carNumber": 0,
                  "team": "McLaren",
                  "timeHours": 0,
                  "timeMinutes": 0,
                  "timeSeconds": 0,
                  "timeMilliseconds": 0,
                  "timeDiference": "+0.292s",
                  "timeString": "00:01:10.570",
                  "nationalityCode": "AUS"
                },
                {
                  "firstName": "Lance",
                  "lastName": "Stroll",
                  "points": "0.000",
                  "nationality": "",
                  "carNumber": 0,
                  "team": "Aston Martin Aramco",
                  "timeHours": 0,
                  "timeMinutes": 0,
                  "timeSeconds": 0,
                  "timeMilliseconds": 0,
                  "timeDiference": "+0.501s",
                  "timeString": "00:01:10.779",
                  "nationalityCode": "CAN"
                }
              ],
              "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Marina_Bay_Street_Circuit.svg",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            }
          },
          {
            "id_juego": "9bv2jh33f28jr26qtwgolbmc",
            "id_liga": "",
            "id_torneo": "",
            "game_name": "2. Dutch Grand Prix / Friday practice 2",
            "class": "clarosports-next-game",
            "phase": "",
            "right_name": "",
            "right_short_name": "",
            "left_name": "",
            "left_short_name": "",
            "left_image": "",
            "right_image": "",
            "period_title": "08:00",
            "score": "",
            "liga": "FIA F1 World Championship 2025",
            "order_league": 1,
            "date": "29 de Ago",
            "current": true,
            "left_class": "",
            "right_class": "",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-29T14:00:00Z",
            "should_print_time": true,
            "sport": "MTR",
            "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=9l7ordv5sqnck0498ityvh444&utm_id=9bv2jh33f28jr26qtwgolbmc&utm_campaign=home_liga_partido&utm_content=dutch_grand_prix",
            "venue_name": "Circuit Zandvoort",
            "venue_state": "Zandvoort",
            "venue_country": "Netherlands",
            "left_score": "",
            "right_score": "",
            "left_seed": "",
            "right_seed": "",
            "left_tenis_score": null,
            "right_tenis_score": null,
            "tenis_fase": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Marina_Bay_Street_Circuit.svg",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            }
          },
          {
            "id_juego": "1wk9z09wu4em60posm46hhjis",
            "id_liga": "",
            "id_torneo": "",
            "game_name": "Dutch Grand Prix / Saturday practice",
            "class": "clarosports-next-game",
            "phase": "",
            "right_name": "",
            "right_short_name": "",
            "left_name": "",
            "left_short_name": "",
            "left_image": "",
            "right_image": "",
            "period_title": "03:30",
            "score": "",
            "liga": "FIA F1 World Championship 2025",
            "order_league": 1,
            "date": "30 de Ago",
            "current": true,
            "left_class": "",
            "right_class": "",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-30T09:30:00Z",
            "should_print_time": true,
            "sport": "MTR",
            "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=9l7ordv5sqnck0498ityvh444&utm_id=1wk9z09wu4em60posm46hhjis&utm_campaign=home_liga_partido&utm_content=dutch_grand_prix",
            "venue_name": "Circuit Zandvoort",
            "venue_state": "Zandvoort",
            "venue_country": "Netherlands",
            "left_score": "",
            "right_score": "",
            "left_seed": "",
            "right_seed": "",
            "left_tenis_score": null,
            "right_tenis_score": null,
            "tenis_fase": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Circuit_Zandvoort.svg",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            }
          },
          {
            "id_juego": "22op31roxa330ymu8fpns1kic",
            "id_liga": "",
            "id_torneo": "",
            "game_name": "Dutch Grand Prix / 1st Qualification",
            "class": "clarosports-next-game",
            "phase": "",
            "right_name": "",
            "right_short_name": "",
            "left_name": "",
            "left_short_name": "",
            "left_image": "",
            "right_image": "",
            "period_title": "07:00",
            "score": "",
            "liga": "FIA F1 World Championship 2025",
            "order_league": 1,
            "date": "30 de Ago",
            "current": true,
            "left_class": "",
            "right_class": "",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-30T13:00:00Z",
            "should_print_time": true,
            "sport": "MTR",
            "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=9l7ordv5sqnck0498ityvh444&utm_id=22op31roxa330ymu8fpns1kic&utm_campaign=home_liga_partido&utm_content=dutch_grand_prix",
            "venue_name": "Circuit Zandvoort",
            "venue_state": "Zandvoort",
            "venue_country": "Netherlands",
            "left_score": "",
            "right_score": "",
            "left_seed": "",
            "right_seed": "",
            "left_tenis_score": null,
            "right_tenis_score": null,
            "tenis_fase": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Circuit_Zandvoort.svg",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            }
          },
          {
            "id_juego": "27fj6lwv9ai0c4ixtwgmdn6l0",
            "id_liga": "",
            "id_torneo": "",
            "game_name": "Dutch Grand Prix / 2nd Qualification",
            "class": "clarosports-next-game",
            "phase": "",
            "right_name": "",
            "right_short_name": "",
            "left_name": "",
            "left_short_name": "",
            "left_image": "",
            "right_image": "",
            "period_title": "07:25",
            "score": "",
            "liga": "FIA F1 World Championship 2025",
            "order_league": 1,
            "date": "30 de Ago",
            "current": true,
            "left_class": "",
            "right_class": "",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-30T13:25:00Z",
            "should_print_time": true,
            "sport": "MTR",
            "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=9l7ordv5sqnck0498ityvh444&utm_id=27fj6lwv9ai0c4ixtwgmdn6l0&utm_campaign=home_liga_partido&utm_content=dutch_grand_prix",
            "venue_name": "Circuit Zandvoort",
            "venue_state": "Zandvoort",
            "venue_country": "Netherlands",
            "left_score": "",
            "right_score": "",
            "left_seed": "",
            "right_seed": "",
            "left_tenis_score": null,
            "right_tenis_score": null,
            "tenis_fase": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Circuit_Zandvoort.svg",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            }
          },
          {
            "id_juego": "2dx21q4iefe7vvyxlgl1yvims",
            "id_liga": "",
            "id_torneo": "",
            "game_name": "Dutch Grand Prix / 3rd Qualification",
            "class": "clarosports-next-game",
            "phase": "",
            "right_name": "",
            "right_short_name": "",
            "left_name": "",
            "left_short_name": "",
            "left_image": "",
            "right_image": "",
            "period_title": "07:48",
            "score": "",
            "liga": "FIA F1 World Championship 2025",
            "order_league": 1,
            "date": "30 de Ago",
            "current": true,
            "left_class": "",
            "right_class": "",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-30T13:48:00Z",
            "should_print_time": true,
            "sport": "MTR",
            "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=9l7ordv5sqnck0498ityvh444&utm_id=2dx21q4iefe7vvyxlgl1yvims&utm_campaign=home_liga_partido&utm_content=dutch_grand_prix",
            "venue_name": "Circuit Zandvoort",
            "venue_state": "Zandvoort",
            "venue_country": "Netherlands",
            "left_score": "",
            "right_score": "",
            "left_seed": "",
            "right_seed": "",
            "left_tenis_score": null,
            "right_tenis_score": null,
            "tenis_fase": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Circuit_Zandvoort.svg",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            }
          }
        ]
      },
      {
        name: "Carrera 22 - Formula 1",
        order: 2,
        live_game_order: 1,
        games: [
          {
            "id_juego": "1ufms779u5bn1asrpq664dedw1",
            "id_liga": "",
            "id_torneo": "",
            "game_name": "1 Hungarian Grand Prix / Race",
            "class": "clarosports-finished-game",
            "phase": "",
            "right_name": "",
            "right_short_name": "",
            "left_name": "",
            "left_short_name": "",
            "left_image": "",
            "right_image": "",
            "period_title": "Final",
            "score": "",
            "liga": "FIA F1 World Championship 2025",
            "order_league": 1,
            "date": "3 de Ago",
            "current": false,
            "left_class": "",
            "right_class": "",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-03T13:00:00Z",
            "should_print_time": false,
            "sport": "MTR",
            "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=ccqsgoagrz9unqcsen1mhlbf8&utm_id=1ufms779u5bn1asrpq664dedw&utm_campaign=home_liga_partido&utm_content=hungarian_grand_prix",
            "venue_name": "Hungaroring",
            "venue_state": "Mogyorod",
            "venue_country": "Hungary",
            "left_score": "",
            "right_score": "",
            "left_seed": "",
            "right_seed": "",
            "left_tenis_score": null,
            "right_tenis_score": null,
            "tenis_fase": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": [
                {
                  "firstName": "Lando",
                  "lastName": "Norris",
                  "points": "25.000",
                  "nationality": "",
                  "carNumber": 0,
                  "team": "McLaren",
                  "timeHours": 0,
                  "timeMinutes": 0,
                  "timeSeconds": 0,
                  "timeMilliseconds": 0,
                  "timeDiference": "+0.000s",
                  "timeString": "01:35:21.231",
                  "nationalityCode": "GBR"
                },
                {
                  "firstName": "Oscar",
                  "lastName": "Piastri",
                  "points": "18.000",
                  "nationality": "",
                  "carNumber": 0,
                  "team": "McLaren",
                  "timeHours": 0,
                  "timeMinutes": 0,
                  "timeSeconds": 0,
                  "timeMilliseconds": 0,
                  "timeDiference": "+0.698s",
                  "timeString": "01:35:21.929",
                  "nationalityCode": "AUS"
                },
                {
                  "firstName": "George",
                  "lastName": "Russell",
                  "points": "15.000",
                  "nationality": "",
                  "carNumber": 0,
                  "team": "Mercedes-AMG Petronas",
                  "timeHours": 0,
                  "timeMinutes": 0,
                  "timeSeconds": 0,
                  "timeMilliseconds": 0,
                  "timeDiference": "+21.916s",
                  "timeString": "01:35:43.147",
                  "nationalityCode": "GBR"
                }
              ],
              "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Hungaroring.svg",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            }
          },
          {
            "id_juego": "16ucohs6tlxtwfzlhlprazn6cz",
            "id_liga": "",
            "id_torneo": "",
            "game_name": "2 Hungarian Grand Prix / 3rd Qualification",
            "class": "clarosports-finished-game",
            "phase": "",
            "right_name": "",
            "right_short_name": "",
            "left_name": "",
            "left_short_name": "",
            "left_image": "",
            "right_image": "",
            "period_title": "Final",
            "score": "",
            "liga": "FIA F1 World Championship 2025",
            "order_league": 1,
            "date": "2 de Ago",
            "current": false,
            "left_class": "",
            "right_class": "",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-02T14:48:00Z",
            "should_print_time": false,
            "sport": "MTR",
            "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=ccqsgoagrz9unqcsen1mhlbf8&utm_id=16ucohs6tlxtwfzlhlprazn6c&utm_campaign=home_liga_partido&utm_content=hungarian_grand_prix",
            "venue_name": "Hungaroring",
            "venue_state": "Mogyorod",
            "venue_country": "Hungary",
            "left_score": "",
            "right_score": "",
            "left_seed": "",
            "right_seed": "",
            "left_tenis_score": null,
            "right_tenis_score": null,
            "tenis_fase": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": [
                {
                  "firstName": "Charles",
                  "lastName": "Leclerc",
                  "points": "0.000",
                  "nationality": "",
                  "carNumber": 0,
                  "team": "Scuderia Ferrari HP",
                  "timeHours": 0,
                  "timeMinutes": 0,
                  "timeSeconds": 0,
                  "timeMilliseconds": 0,
                  "timeDiference": "+0.000s",
                  "timeString": "00:01:15.372",
                  "nationalityCode": "MON"
                },
                {
                  "firstName": "Oscar",
                  "lastName": "Piastri",
                  "points": "0.000",
                  "nationality": "",
                  "carNumber": 0,
                  "team": "McLaren",
                  "timeHours": 0,
                  "timeMinutes": 0,
                  "timeSeconds": 0,
                  "timeMilliseconds": 0,
                  "timeDiference": "+0.026s",
                  "timeString": "00:01:15.398",
                  "nationalityCode": "AUS"
                },
                {
                  "firstName": "Lando",
                  "lastName": "Norris",
                  "points": "0.000",
                  "nationality": "",
                  "carNumber": 0,
                  "team": "McLaren",
                  "timeHours": 0,
                  "timeMinutes": 0,
                  "timeSeconds": 0,
                  "timeMilliseconds": 0,
                  "timeDiference": "+0.041s",
                  "timeString": "00:01:15.413",
                  "nationalityCode": "GBR"
                }
              ],
              "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Hungaroring.svg",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            }
          },
          {
            "id_juego": "10tx55iyesumqv4zlx69quy381",
            "id_liga": "",
            "id_torneo": "",
            "game_name": "3 Hungarian Grand Prix / 2nd Qualification",
            "class": "clarosports-finished-game",
            "phase": "",
            "right_name": "",
            "right_short_name": "",
            "left_name": "",
            "left_short_name": "",
            "left_image": "",
            "right_image": "",
            "period_title": "Final",
            "score": "",
            "liga": "FIA F1 World Championship 2025",
            "order_league": 1,
            "date": "2 de Ago",
            "current": false,
            "left_class": "",
            "right_class": "",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-02T14:25:00Z",
            "should_print_time": false,
            "sport": "MTR",
            "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=ccqsgoagrz9unqcsen1mhlbf8&utm_id=10tx55iyesumqv4zlx69quy38&utm_campaign=home_liga_partido&utm_content=hungarian_grand_prix",
            "venue_name": "Hungaroring",
            "venue_state": "Mogyorod",
            "venue_country": "Hungary",
            "left_score": "",
            "right_score": "",
            "left_seed": "",
            "right_seed": "",
            "left_tenis_score": null,
            "right_tenis_score": null,
            "tenis_fase": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": [
                {
                  "firstName": "Lando",
                  "lastName": "Norris",
                  "points": "0.000",
                  "nationality": "",
                  "carNumber": 0,
                  "team": "McLaren",
                  "timeHours": 0,
                  "timeMinutes": 0,
                  "timeSeconds": 0,
                  "timeMilliseconds": 0,
                  "timeDiference": "+0.000s",
                  "timeString": "00:01:14.890",
                  "nationalityCode": "GBR"
                },
                {
                  "firstName": "Oscar",
                  "lastName": "Piastri",
                  "points": "0.000",
                  "nationality": "",
                  "carNumber": 0,
                  "team": "McLaren",
                  "timeHours": 0,
                  "timeMinutes": 0,
                  "timeSeconds": 0,
                  "timeMilliseconds": 0,
                  "timeDiference": "+0.051s",
                  "timeString": "00:01:14.941",
                  "nationalityCode": "AUS"
                },
                {
                  "firstName": "Lance",
                  "lastName": "Stroll",
                  "points": "0.000",
                  "nationality": "",
                  "carNumber": 0,
                  "team": "Aston Martin Aramco",
                  "timeHours": 0,
                  "timeMinutes": 0,
                  "timeSeconds": 0,
                  "timeMilliseconds": 0,
                  "timeDiference": "+0.239s",
                  "timeString": "00:01:15.129",
                  "nationalityCode": "CAN"
                }
              ],
              "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Hungaroring.svg",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            }
          }
        ]
      }
    ]
  }
];


export const nbl =
{
  "eventTypeId": 2,
  "name": "Prueba Season",
  "events": null,
  "conferences": [
    {
      "conferenceId": 5,
      "name": "American League",
      "abbreviation": "AL",
      "divisions": [
        {
          "divisionsId": 0,
          "name": "East Division",
          "abbreviation": "East",
          "teams": [
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 238,
              "nickname": "Blue Jays",
              "location": "Toronto",
              "abbreviation": "TOR",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 1,
                "seed": 1,
                "gamesBehind": 0
              },
              "record": {
                "wins": 20,
                "losses": 30,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 226,
              "nickname": "Red Sox",
              "location": "Boston",
              "abbreviation": "BOS",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 2,
                "seed": 2,
                "gamesBehind": 4.5
              },
              "record": {
                "wins": 10,
                "losses": 25,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 234,
              "nickname": "Yankees",
              "location": "New York",
              "abbreviation": "NYY",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 3,
                "seed": 3,
                "gamesBehind": 6
              },
              "record": {
                "wins": 23,
                "losses": 34,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 254,
              "nickname": "Rays",
              "location": "Tampa Bay",
              "abbreviation": "TB",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 4,
                "seed": 4,
                "gamesBehind": 12.5
              },
              "record": {
                "wins": 12,
                "losses": 30,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 225,
              "nickname": "Orioles",
              "location": "Baltimore",
              "abbreviation": "BAL",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 5,
                "seed": 5,
                "gamesBehind": 16.5
              },
              "record": {
                "wins": 43,
                "losses": 86,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            }
          ]
        },
        {
          "divisionsId": 0,
          "name": "Central Division",
          "abbreviation": "Central",
          "teams": [
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 230,
              "nickname": "Tigers",
              "location": "Detroit",
              "abbreviation": "DET",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 1,
                "seed": 1,
                "gamesBehind": 0
              },
              "record": {
                "wins": 69,
                "losses": 52,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 229,
              "nickname": "Guardians",
              "location": "Cleveland",
              "abbreviation": "CLE",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 2,
                "seed": 2,
                "gamesBehind": 5.5
              },
              "record": {
                "wins": 62,
                "losses": 56,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 231,
              "nickname": "Royals",
              "location": "Kansas City",
              "abbreviation": "KC",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 3,
                "seed": 3,
                "gamesBehind": 8.5
              },
              "record": {
                "wins": 60,
                "losses": 60,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 233,
              "nickname": "Twins",
              "location": "Minnesota",
              "abbreviation": "MIN",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 4,
                "seed": 4,
                "gamesBehind": 12
              },
              "record": {
                "wins": 56,
                "losses": 63,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 228,
              "nickname": "White Sox",
              "location": "Chicago",
              "abbreviation": "CWS",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 5,
                "seed": 5,
                "gamesBehind": 24.5
              },
              "record": {
                "wins": 44,
                "losses": 76,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            }
          ]
        },
        {
          "divisionsId": 0,
          "name": "West Division",
          "abbreviation": "West",
          "teams": [
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 236,
              "nickname": "Mariners",
              "location": "Seattle",
              "abbreviation": "SEA",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 1,
                "seed": 1,
                "gamesBehind": 0
              },
              "record": {
                "wins": 67,
                "losses": 53,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 242,
              "nickname": "Astros",
              "location": "Houston",
              "abbreviation": "HOU",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 2,
                "seed": 2,
                "gamesBehind": 0
              },
              "record": {
                "wins": 67,
                "losses": 53,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 237,
              "nickname": "Rangers",
              "location": "Texas",
              "abbreviation": "TEX",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 3,
                "seed": 3,
                "gamesBehind": 6.5
              },
              "record": {
                "wins": 61,
                "losses": 60,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 227,
              "nickname": "Angels",
              "location": "Los Angeles",
              "abbreviation": "LAA",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 4,
                "seed": 4,
                "gamesBehind": 9
              },
              "record": {
                "wins": 58,
                "losses": 62,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 235,
              "nickname": "",
              "location": "Athletics",
              "abbreviation": "ATH",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 5,
                "seed": 5,
                "gamesBehind": 14
              },
              "record": {
                "wins": 54,
                "losses": 68,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            }
          ]
        }
      ]
    },
    {
      "conferenceId": 6,
      "name": "National League",
      "abbreviation": "NL",
      "divisions": [
        {
          "divisionsId": 0,
          "name": "East Division",
          "abbreviation": "East",
          "teams": [
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 246,
              "nickname": "Phillies",
              "location": "Philadelphia",
              "abbreviation": "PHI",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 1,
                "seed": 1,
                "gamesBehind": 0
              },
              "record": {
                "wins": 69,
                "losses": 50,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 245,
              "nickname": "Mets",
              "location": "New York",
              "abbreviation": "NYM",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 2,
                "seed": 2,
                "gamesBehind": 5
              },
              "record": {
                "wins": 64,
                "losses": 55,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 252,
              "nickname": "Marlins",
              "location": "Miami",
              "abbreviation": "MIA",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 3,
                "seed": 3,
                "gamesBehind": 12
              },
              "record": {
                "wins": 57,
                "losses": 62,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 239,
              "nickname": "Braves",
              "location": "Atlanta",
              "abbreviation": "ATL",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 4,
                "seed": 4,
                "gamesBehind": 18
              },
              "record": {
                "wins": 51,
                "losses": 68,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 244,
              "nickname": "Nationals",
              "location": "Washington",
              "abbreviation": "WSH",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 5,
                "seed": 5,
                "gamesBehind": 22
              },
              "record": {
                "wins": 47,
                "losses": 72,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            }
          ]
        },
        {
          "divisionsId": 0,
          "name": "Central Division",
          "abbreviation": "Central",
          "teams": [
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 232,
              "nickname": "Brewers",
              "location": "Milwaukee",
              "abbreviation": "MIL",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 1,
                "seed": 1,
                "gamesBehind": 0
              },
              "record": {
                "wins": 75,
                "losses": 44,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 240,
              "nickname": "Cubs",
              "location": "Chicago",
              "abbreviation": "CHC",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 2,
                "seed": 2,
                "gamesBehind": 7.5
              },
              "record": {
                "wins": 67,
                "losses": 51,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 241,
              "nickname": "Reds",
              "location": "Cincinnati",
              "abbreviation": "CIN",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 3,
                "seed": 3,
                "gamesBehind": 13
              },
              "record": {
                "wins": 63,
                "losses": 58,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 248,
              "nickname": "Cardinals",
              "location": "St. Louis",
              "abbreviation": "STL",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 4,
                "seed": 4,
                "gamesBehind": 15
              },
              "record": {
                "wins": 61,
                "losses": 60,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 247,
              "nickname": "Pirates",
              "location": "Pittsburgh",
              "abbreviation": "PIT",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 5,
                "seed": 5,
                "gamesBehind": 25
              },
              "record": {
                "wins": 51,
                "losses": 70,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            }
          ]
        },
        {
          "divisionsId": 0,
          "name": "West Division",
          "abbreviation": "West",
          "teams": [
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 243,
              "nickname": "Dodgers",
              "location": "Los Angeles",
              "abbreviation": "LAD",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 1,
                "seed": 1,
                "gamesBehind": 0
              },
              "record": {
                "wins": 68,
                "losses": 52,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 249,
              "nickname": "Padres",
              "location": "San Diego",
              "abbreviation": "SD",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 2,
                "seed": 2,
                "gamesBehind": 0
              },
              "record": {
                "wins": 68,
                "losses": 52,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 250,
              "nickname": "Giants",
              "location": "San Francisco",
              "abbreviation": "SF",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 3,
                "seed": 3,
                "gamesBehind": 9
              },
              "record": {
                "wins": 59,
                "losses": 61,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 253,
              "nickname": "Diamondbacks",
              "location": "Arizona",
              "abbreviation": "ARI",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 4,
                "seed": 4,
                "gamesBehind": 10
              },
              "record": {
                "wins": 58,
                "losses": 62,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            },
            {
              "logo": "https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=65&id=buyj9j0qwgbvx3v8wzikpjyzu",
              "teamId": 251,
              "nickname": "Rockies",
              "location": "Colorado",
              "abbreviation": "COL",
              "score": 0,
              "linescoreTotals": {
                "runs": 0
              },
              "isWinner": false,
              "division": {
                "rank": 5,
                "seed": 5,
                "gamesBehind": 36.5
              },
              "record": {
                "wins": 31,
                "losses": 88,
                "ties": 0,
                "winPercentage": ""
              },
              "streak": null
            }
          ]
        }
      ]
    }
  ]
}

//fut americano
export const NFL = [
  {
    "id_juego": "2879567",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Steelers v Panthers",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Panthers",
    "right_short_name": "Car",
    "left_name": "Steelers",
    "left_short_name": "Pit",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/356.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/364.png",
    "period_title": "16:00",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "21 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-21T23:00:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879567&utm_id=2879567&utm_campaign=home_liga_partido&utm_content=steelers_v_panthers",
    "venue_name": "Bank of America Stadium",
    "venue_state": "NC",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879570",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Patriots v Giants",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Giants",
    "right_short_name": "NYG",
    "left_name": "Patriots",
    "left_short_name": "NE",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/348.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/351.png",
    "period_title": "17:00",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "21 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-22T00:00:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879570&utm_id=2879570&utm_campaign=home_liga_partido&utm_content=patriots_v_giants",
    "venue_name": "MetLife Stadium",
    "venue_state": "NJ",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879557",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Eagles v Jets",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Jets",
    "right_short_name": "NYJ",
    "left_name": "Eagles",
    "left_short_name": "Phi",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/354.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/352.png",
    "period_title": "16:30",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "22 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-22T23:30:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879557&utm_id=2879557&utm_campaign=home_liga_partido&utm_content=eagles_v_jets",
    "venue_name": "MetLife Stadium",
    "venue_state": "NJ",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879574",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Vikings v Titans",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Titans",
    "right_short_name": "Ten",
    "left_name": "Vikings",
    "left_short_name": "Min",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/347.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/336.png",
    "period_title": "17:00",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "22 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-23T00:00:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879574&utm_id=2879574&utm_campaign=home_liga_partido&utm_content=vikings_v_titans",
    "venue_name": "Nissan Stadium",
    "venue_state": "TN",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879579",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Falcons v Cowboys",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Cowboys",
    "right_short_name": "Dal",
    "left_name": "Falcons",
    "left_short_name": "Atl",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/323.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/331.png",
    "period_title": "17:00",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "22 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-23T00:00:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879579&utm_id=2879579&utm_campaign=home_liga_partido&utm_content=falcons_v_cowboys",
    "venue_name": "AT&T Stadium",
    "venue_state": "TX",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879559",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Bears v Chiefs",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Chiefs",
    "right_short_name": "KC",
    "left_name": "Bears",
    "left_short_name": "Chi",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/326.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/339.png",
    "period_title": "17:20",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "22 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-23T00:20:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879559&utm_id=2879559&utm_campaign=home_liga_partido&utm_content=bears_v_chiefs",
    "venue_name": "GEHA Field at Arrowhead Stadium",
    "venue_state": "MO",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2880470",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Ravens v Commanders",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Commanders",
    "right_short_name": "Was",
    "left_name": "Ravens",
    "left_short_name": "Bal",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/366.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/363.png",
    "period_title": "09:00",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "23 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-23T16:00:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2880470&utm_id=2880470&utm_campaign=home_liga_partido&utm_content=ravens_v_commanders",
    "venue_name": "Northwest Stadium",
    "venue_state": "MD",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879587",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Broncos v Saints",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Saints",
    "right_short_name": "NO",
    "left_name": "Broncos",
    "left_short_name": "Den",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/332.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/350.png",
    "period_title": "10:00",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "23 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-23T17:00:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879587&utm_id=2879587&utm_campaign=home_liga_partido&utm_content=broncos_v_saints",
    "venue_name": "Caesars Superdome",
    "venue_state": "LA",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879563",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Colts v Bengals",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Bengals",
    "right_short_name": "Cin",
    "left_name": "Colts",
    "left_short_name": "Ind",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/338.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/327.png",
    "period_title": "10:00",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "23 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-23T17:00:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879563&utm_id=2879563&utm_campaign=home_liga_partido&utm_content=colts_v_bengals",
    "venue_name": "Paycor Stadium",
    "venue_state": "OH",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879598",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Rams v Browns",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Browns",
    "right_short_name": "Cle",
    "left_name": "Rams",
    "left_short_name": "LAR",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/343.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/329.png",
    "period_title": "10:00",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "23 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-23T17:00:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879598&utm_id=2879598&utm_campaign=home_liga_partido&utm_content=rams_v_browns",
    "venue_name": "Huntington Bank Field",
    "venue_state": "OH",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879797",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Texans v Lions",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Lions",
    "right_short_name": "Det",
    "left_name": "Texans",
    "left_short_name": "Hou",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/325.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/334.png",
    "period_title": "10:00",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "23 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-23T17:00:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879797&utm_id=2879797&utm_campaign=home_liga_partido&utm_content=texans_v_lions",
    "venue_name": "Ford Field",
    "venue_state": "MI",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879576",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Seahawks v Packers",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Packers",
    "right_short_name": "GB",
    "left_name": "Seahawks",
    "left_short_name": "Sea",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/361.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/335.png",
    "period_title": "13:00",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "23 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-23T20:00:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879576&utm_id=2879576&utm_campaign=home_liga_partido&utm_content=seahawks_v_packers",
    "venue_name": "Lambeau Field",
    "venue_state": "WI",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2880134",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Jaguars v Dolphins",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Dolphins",
    "right_short_name": "Mia",
    "left_name": "Jaguars",
    "left_short_name": "Jax",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/365.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/345.png",
    "period_title": "16:00",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "23 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-23T23:00:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2880134&utm_id=2880134&utm_campaign=home_liga_partido&utm_content=jaguars_v_dolphins",
    "venue_name": "Hard Rock Stadium",
    "venue_state": "FL",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879659",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Bills v Buccaneers",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Buccaneers",
    "right_short_name": "TB",
    "left_name": "Bills",
    "left_short_name": "Buf",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/324.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/362.png",
    "period_title": "16:30",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "23 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-23T23:30:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879659&utm_id=2879659&utm_campaign=home_liga_partido&utm_content=bills_v_buccaneers",
    "venue_name": "Raymond James Stadium",
    "venue_state": "FL",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2880090",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Chargers v 49ers",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "49ers",
    "right_short_name": "SF",
    "left_name": "Chargers",
    "left_short_name": "LAC",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/357.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/359.png",
    "period_title": "17:30",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "23 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-24T00:30:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2880090&utm_id=2880090&utm_campaign=home_liga_partido&utm_content=chargers_v_49ers",
    "venue_name": "Levi's Stadium",
    "venue_state": "CA",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879795",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Raiders v Cardinals",
    "class": "clarosports-next-game",
    "phase": "Semana 4",
    "right_name": "Cardinals",
    "right_short_name": "Ari",
    "left_name": "Raiders",
    "left_short_name": "LV",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/341.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/355.png",
    "period_title": "19:00",
    "score": "VS",
    "liga": "National Football League",
    "order_league": 1,
    "date": "23 de Ago",
    "current": true,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-24T02:00:00Z",
    "should_print_time": true,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879795&utm_id=2879795&utm_campaign=home_liga_partido&utm_content=raiders_v_cardinals",
    "venue_name": "State Farm Stadium",
    "venue_state": "AZ",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "0",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879562",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Bengals v Commanders",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Commanders",
    "right_short_name": "Was",
    "left_name": "Bengals",
    "left_short_name": "Cin",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/327.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/363.png",
    "period_title": "Final",
    "score": "31 - 17",
    "liga": "National Football League",
    "order_league": 1,
    "date": "18 de Ago",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-19T00:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879562&utm_id=2879562&utm_campaign=home_liga_partido&utm_content=bengals_v_commanders",
    "venue_name": "Northwest Stadium",
    "venue_state": "MD",
    "venue_country": "USA",
    "left_score": "31",
    "right_score": "17",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879558",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Bills v Bears",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Bears",
    "right_short_name": "Chi",
    "left_name": "Bills",
    "left_short_name": "Buf",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/324.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/326.png",
    "period_title": "Final",
    "score": "0 - 38",
    "liga": "National Football League",
    "order_league": 1,
    "date": "17 de Ago",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-18T00:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879558&utm_id=2879558&utm_campaign=home_liga_partido&utm_content=bills_v_bears",
    "venue_name": "Soldier Field",
    "venue_state": "IL",
    "venue_country": "USA",
    "left_score": "0",
    "right_score": "38",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879585",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Jaguars v Saints",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Saints",
    "right_short_name": "NO",
    "left_name": "Jaguars",
    "left_short_name": "Jax",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/365.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/350.png",
    "period_title": "Final",
    "score": "17 - 17",
    "liga": "National Football League",
    "order_league": 1,
    "date": "17 de Ago",
    "current": false,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-17T17:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879585&utm_id=2879585&utm_campaign=home_liga_partido&utm_content=jaguars_v_saints",
    "venue_name": "Caesars Superdome",
    "venue_state": "LA",
    "venue_country": "USA",
    "left_score": "17",
    "right_score": "17",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879914",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Cardinals v Broncos",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Broncos",
    "right_short_name": "Den",
    "left_name": "Cardinals",
    "left_short_name": "Ari",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/355.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/332.png",
    "period_title": "Final",
    "score": "7 - 27",
    "liga": "National Football League",
    "order_league": 1,
    "date": "16 de Ago",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-17T01:30:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879914&utm_id=2879914&utm_campaign=home_liga_partido&utm_content=cardinals_v_broncos",
    "venue_name": "Empower Field at Mile High",
    "venue_state": "CO",
    "venue_country": "USA",
    "left_score": "7",
    "right_score": "27",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879561",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Ravens v Cowboys",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Cowboys",
    "right_short_name": "Dal",
    "left_name": "Ravens",
    "left_short_name": "Bal",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/366.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/331.png",
    "period_title": "Final",
    "score": "31 - 13",
    "liga": "National Football League",
    "order_league": 1,
    "date": "16 de Ago",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-16T23:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879561&utm_id=2879561&utm_campaign=home_liga_partido&utm_content=ravens_v_cowboys",
    "venue_name": "AT&T Stadium",
    "venue_state": "TX",
    "venue_country": "USA",
    "left_score": "31",
    "right_score": "13",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879572",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Jets v Giants",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Giants",
    "right_short_name": "NYG",
    "left_name": "Jets",
    "left_short_name": "NYJ",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/352.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/351.png",
    "period_title": "Final",
    "score": "12 - 31",
    "liga": "National Football League",
    "order_league": 1,
    "date": "16 de Ago",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-16T23:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879572&utm_id=2879572&utm_campaign=home_liga_partido&utm_content=jets_v_giants",
    "venue_name": "MetLife Stadium",
    "venue_state": "NJ",
    "venue_country": "USA",
    "left_score": "12",
    "right_score": "31",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879566",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Buccaneers v Steelers",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Steelers",
    "right_short_name": "Pit",
    "left_name": "Buccaneers",
    "left_short_name": "TB",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/362.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/356.png",
    "period_title": "Final",
    "score": "17 - 14",
    "liga": "National Football League",
    "order_league": 1,
    "date": "16 de Ago",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-16T23:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879566&utm_id=2879566&utm_campaign=home_liga_partido&utm_content=buccaneers_v_steelers",
    "venue_name": "Acrisure Stadium",
    "venue_state": "PA",
    "venue_country": "USA",
    "left_score": "17",
    "right_score": "14",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879609",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Chargers v Rams",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Rams",
    "right_short_name": "LAR",
    "left_name": "Chargers",
    "left_short_name": "LAC",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/357.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/343.png",
    "period_title": "Final",
    "score": "22 - 23",
    "liga": "National Football League",
    "order_league": 1,
    "date": "16 de Ago",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-16T23:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879609&utm_id=2879609&utm_campaign=home_liga_partido&utm_content=chargers_v_rams",
    "venue_name": "SoFi Stadium",
    "venue_state": "CA",
    "venue_country": "USA",
    "left_score": "22",
    "right_score": "23",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879794",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "49ers v Raiders",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Raiders",
    "right_short_name": "LV",
    "left_name": "49ers",
    "left_short_name": "SF",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/359.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/341.png",
    "period_title": "Final",
    "score": "22 - 19",
    "liga": "National Football League",
    "order_league": 1,
    "date": "16 de Ago",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-16T20:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879794&utm_id=2879794&utm_campaign=home_liga_partido&utm_content=49ers_v_raiders",
    "venue_name": "Allegiant Stadium",
    "venue_state": "NV",
    "venue_country": "USA",
    "left_score": "22",
    "right_score": "19",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879569",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Patriots v Vikings",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Vikings",
    "right_short_name": "Min",
    "left_name": "Patriots",
    "left_short_name": "NE",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/348.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/347.png",
    "period_title": "Final",
    "score": "20 - 12",
    "liga": "National Football League",
    "order_league": 1,
    "date": "16 de Ago",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-16T17:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879569&utm_id=2879569&utm_campaign=home_liga_partido&utm_content=patriots_v_vikings",
    "venue_name": "U.S. Bank Stadium",
    "venue_state": "MN",
    "venue_country": "USA",
    "left_score": "20",
    "right_score": "12",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879610",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Panthers v Texans",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Texans",
    "right_short_name": "Hou",
    "left_name": "Panthers",
    "left_short_name": "Car",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/364.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/325.png",
    "period_title": "Final",
    "score": "3 - 20",
    "liga": "National Football League",
    "order_league": 1,
    "date": "16 de Ago",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-16T17:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879610&utm_id=2879610&utm_campaign=home_liga_partido&utm_content=panthers_v_texans",
    "venue_name": "NRG Stadium",
    "venue_state": "TX",
    "venue_country": "USA",
    "left_score": "3",
    "right_score": "20",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879911",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Dolphins v Lions",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Lions",
    "right_short_name": "Det",
    "left_name": "Dolphins",
    "left_short_name": "Mia",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/345.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/334.png",
    "period_title": "Final",
    "score": "24 - 17",
    "liga": "National Football League",
    "order_league": 1,
    "date": "16 de Ago",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-16T17:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879911&utm_id=2879911&utm_campaign=home_liga_partido&utm_content=dolphins_v_lions",
    "venue_name": "Ford Field",
    "venue_state": "MI",
    "venue_country": "USA",
    "left_score": "24",
    "right_score": "17",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879541",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Browns v Eagles",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Eagles",
    "right_short_name": "Phi",
    "left_name": "Browns",
    "left_short_name": "Cle",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/329.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/354.png",
    "period_title": "Final",
    "score": "22 - 13",
    "liga": "National Football League",
    "order_league": 1,
    "date": "16 de Ago",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-16T17:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879541&utm_id=2879541&utm_campaign=home_liga_partido&utm_content=browns_v_eagles",
    "venue_name": "Lincoln Financial Field",
    "venue_state": "PA",
    "venue_country": "USA",
    "left_score": "22",
    "right_score": "13",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879573",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Packers v Colts",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Colts",
    "right_short_name": "Ind",
    "left_name": "Packers",
    "left_short_name": "GB",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/335.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/338.png",
    "period_title": "Final",
    "score": "23 - 19",
    "liga": "National Football League",
    "order_league": 1,
    "date": "16 de Ago",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-16T17:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879573&utm_id=2879573&utm_campaign=home_liga_partido&utm_content=packers_v_colts",
    "venue_name": "Lucas Oil Stadium",
    "venue_state": "IN",
    "venue_country": "USA",
    "left_score": "23",
    "right_score": "19",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879796",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Chiefs v Seahawks",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Seahawks",
    "right_short_name": "Sea",
    "left_name": "Chiefs",
    "left_short_name": "KC",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/339.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/361.png",
    "period_title": "Final",
    "score": "16 - 33",
    "liga": "National Football League",
    "order_league": 1,
    "date": "15 de Ago",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-16T02:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879796&utm_id=2879796&utm_campaign=home_liga_partido&utm_content=chiefs_v_seahawks",
    "venue_name": "Lumen Field",
    "venue_state": "WA",
    "venue_country": "USA",
    "left_score": "16",
    "right_score": "33",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879593",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Titans v Falcons",
    "class": "clarosports-finished-game",
    "phase": "Semana 3",
    "right_name": "Falcons",
    "right_short_name": "Atl",
    "left_name": "Titans",
    "left_short_name": "Ten",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/336.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/323.png",
    "period_title": "Final",
    "score": "23 - 20",
    "liga": "National Football League",
    "order_league": 1,
    "date": "15 de Ago",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-15T23:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879593&utm_id=2879593&utm_campaign=home_liga_partido&utm_content=titans_v_falcons",
    "venue_name": "Mercedes-Benz Stadium",
    "venue_state": "GA",
    "venue_country": "USA",
    "left_score": "23",
    "right_score": "20",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879582",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Saints v Chargers",
    "class": "clarosports-finished-game",
    "phase": "Semana 2",
    "right_name": "Chargers",
    "right_short_name": "LAC",
    "left_name": "Saints",
    "left_short_name": "NO",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/350.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/357.png",
    "period_title": "Final",
    "score": "13 - 27",
    "liga": "National Football League",
    "order_league": 1,
    "date": "10 de Ago",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-10T20:05:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879582&utm_id=2879582&utm_campaign=home_liga_partido&utm_content=saints_v_chargers",
    "venue_name": "SoFi Stadium",
    "venue_state": "CA",
    "venue_country": "USA",
    "left_score": "13",
    "right_score": "27",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2880133",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Dolphins v Bears",
    "class": "clarosports-finished-game",
    "phase": "Semana 2",
    "right_name": "Bears",
    "right_short_name": "Chi",
    "left_name": "Dolphins",
    "left_short_name": "Mia",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/345.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/326.png",
    "period_title": "Final",
    "score": "24 - 24",
    "liga": "National Football League",
    "order_league": 1,
    "date": "10 de Ago",
    "current": false,
    "left_class": "clarosports-draw",
    "right_class": "clarosports-draw",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-10T17:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2880133&utm_id=2880133&utm_campaign=home_liga_partido&utm_content=dolphins_v_bears",
    "venue_name": "Soldier Field",
    "venue_state": "IL",
    "venue_country": "USA",
    "left_score": "24",
    "right_score": "24",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2880089",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Broncos v 49ers",
    "class": "clarosports-finished-game",
    "phase": "Semana 2",
    "right_name": "49ers",
    "right_short_name": "SF",
    "left_name": "Broncos",
    "left_short_name": "Den",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/332.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/359.png",
    "period_title": "Final",
    "score": "30 - 9",
    "liga": "National Football League",
    "order_league": 1,
    "date": "9 de Ago",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-10T00:30:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2880089&utm_id=2880089&utm_campaign=home_liga_partido&utm_content=broncos_v_49ers",
    "venue_name": "Levi's Stadium",
    "venue_state": "CA",
    "venue_country": "USA",
    "left_score": "30",
    "right_score": "9",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2879571",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Jets v Packers",
    "class": "clarosports-finished-game",
    "phase": "Semana 2",
    "right_name": "Packers",
    "right_short_name": "GB",
    "left_name": "Jets",
    "left_short_name": "NYJ",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/352.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/335.png",
    "period_title": "Final",
    "score": "30 - 10",
    "liga": "National Football League",
    "order_league": 1,
    "date": "9 de Ago",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-08-10T00:00:00Z",
    "should_print_time": false,
    "sport": "AMFO",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879571&utm_id=2879571&utm_campaign=home_liga_partido&utm_content=jets_v_packers",
    "venue_name": "Lambeau Field",
    "venue_state": "WI",
    "venue_country": "USA",
    "left_score": "30",
    "right_score": "10",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  }
]

// basket
export const NBA = [
  {
    "id_juego": "2694721",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Thunder v Timberwolves",
    "class": "clarosports-in-progress-game",
    "phase": "",
    "right_name": "Timberwolves",
    "right_short_name": "MIN",
    "left_name": "Thunder",
    "left_short_name": "OKC",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/25.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/16.png",
    "period_title": "Final",
    "score": "101 - 116",
    "liga": "NBA",
    "order_league": 1,
    "date": "13 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-14T01:30:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2694721&utm_id=2694721&utm_campaign=home_liga_partido&utm_content=thunder_v_timberwolves",
    "venue_name": "Target Center",
    "venue_state": "MN",
    "venue_country": "USA",
    "left_score": "101",
    "right_score": "116",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 2,
          "losses": 2,
          "ties": 0,
          "percentage": ".500",
          "winPercentage": ""
        },
        "linescores": [
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 1,
            "score": 0
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 2,
            "score": 13
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 3,
            "score": 0
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 4,
            "score": 10
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 5,
            "score": 11
          }
        ]
      },
      "right_stats": {
        "record": {
          "wins": 2,
          "losses": 1,
          "ties": 0,
          "percentage": ".667",
          "winPercentage": ""
        },
        "linescores": [
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 1,
            "score": 0
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 2,
            "score": 6
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 3,
            "score": 10
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 4,
            "score": 14
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 5,
            "score": 14
          }
        ]
      }
    }
  },
  {
    "id_juego": "2693910",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Heat v Mavericks",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Mavericks",
    "right_short_name": "DAL",
    "left_name": "Heat",
    "left_short_name": "MIA",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/14.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/6.png",
    "period_title": "Final",
    "score": "113 - 118",
    "liga": "NBA",
    "order_league": 1,
    "date": "13 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-14T01:30:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2693910&utm_id=2693910&utm_campaign=home_liga_partido&utm_content=heat_v_mavericks",
    "venue_name": "American Airlines Center",
    "venue_state": "TX",
    "venue_country": "USA",
    "left_score": "113",
    "right_score": "118",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 2,
          "losses": 2,
          "ties": 0,
          "percentage": ".500",
          "winPercentage": ""
        },
        "linescores": [
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 1,
            "score": 0
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 2,
            "score": 13
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 3,
            "score": 0
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 4,
            "score": 10
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 5,
            "score": 11
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 7,
            "score": 17
          }
        ]
      },
      "right_stats": {
        "record": {
          "wins": 2,
          "losses": 1,
          "ties": 0,
          "percentage": ".667",
          "winPercentage": ""
        },
        "linescores": [
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 1,
            "score": 0
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 2,
            "score": 6
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 3,
            "score": 10
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 4,
            "score": 14
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 5,
            "score": 14
          },
          {
            "runs": 0,
            "hits": 0,
            "errors": 0,
            "period": 7,
            "score": 15
          }
        ]
      }
    }
  },
  {
    "id_juego": "2694203",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Warriors v Rockets",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Rockets",
    "right_short_name": "HOU",
    "left_name": "Warriors",
    "left_short_name": "GSW",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/9.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/10.png",
    "period_title": "Final",
    "score": "105 - 98",
    "liga": "NBA",
    "order_league": 1,
    "date": "13 de Feb",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-14T01:00:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2694203&utm_id=2694203&utm_campaign=home_liga_partido&utm_content=warriors_v_rockets",
    "venue_name": "Toyota Center",
    "venue_state": "TX",
    "venue_country": "USA",
    "left_score": "105",
    "right_score": "98",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2694490",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Kings v Pelicans",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Pelicans",
    "right_short_name": "NOP",
    "left_name": "Kings",
    "left_short_name": "SAC",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/23.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/3.png",
    "period_title": "Final",
    "score": "133 - 140",
    "liga": "NBA",
    "order_league": 1,
    "date": "13 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-14T01:00:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2694490&utm_id=2694490&utm_campaign=home_liga_partido&utm_content=kings_v_pelicans",
    "venue_name": "Smoothie King Center",
    "venue_state": "LA",
    "venue_country": "USA",
    "left_score": "133",
    "right_score": "140",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2694358",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Grizzlies v Clippers",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Clippers",
    "right_short_name": "LAC",
    "left_name": "Grizzlies",
    "left_short_name": "MEM",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/29.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/12.png",
    "period_title": "Final",
    "score": "114 - 128",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T03:30:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2694358&utm_id=2694358&utm_campaign=home_liga_partido&utm_content=grizzlies_v_clippers",
    "venue_name": "Intuit Dome",
    "venue_state": "CA",
    "venue_country": "USA",
    "left_score": "114",
    "right_score": "128",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2693908",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Warriors v Mavericks",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Mavericks",
    "right_short_name": "DAL",
    "left_name": "Warriors",
    "left_short_name": "GSW",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/9.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/6.png",
    "period_title": "Final",
    "score": "107 - 111",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T02:30:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2693908&utm_id=2693908&utm_campaign=home_liga_partido&utm_content=warriors_v_mavericks",
    "venue_name": "American Airlines Center",
    "venue_state": "TX",
    "venue_country": "USA",
    "left_score": "107",
    "right_score": "111",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2693892",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Lakers v Jazz",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Jazz",
    "right_short_name": "UTA",
    "left_name": "Lakers",
    "left_short_name": "LAL",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/13.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/26.png",
    "period_title": "Final",
    "score": "119 - 131",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T02:00:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2693892&utm_id=2693892&utm_campaign=home_liga_partido&utm_content=lakers_v_jazz",
    "venue_name": "Delta Center",
    "venue_state": "UT",
    "venue_country": "USA",
    "left_score": "119",
    "right_score": "131",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2693955",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Trail Blazers v Nuggets",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Nuggets",
    "right_short_name": "DEN",
    "left_name": "Trail Blazers",
    "left_short_name": "POR",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/22.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/7.png",
    "period_title": "Final",
    "score": "121 - 132",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T02:00:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2693955&utm_id=2693955&utm_campaign=home_liga_partido&utm_content=trail_blazers_v_nuggets",
    "venue_name": "Ball Arena",
    "venue_state": "CO",
    "venue_country": "USA",
    "left_score": "121",
    "right_score": "132",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2694201",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Suns v Rockets",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Rockets",
    "right_short_name": "HOU",
    "left_name": "Suns",
    "left_short_name": "PHX",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/21.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/10.png",
    "period_title": "Final",
    "score": "111 - 119",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T01:30:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2694201&utm_id=2694201&utm_campaign=home_liga_partido&utm_content=suns_v_rockets",
    "venue_name": "Toyota Center",
    "venue_state": "TX",
    "venue_country": "USA",
    "left_score": "111",
    "right_score": "119",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2694677",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Heat v Thunder",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Thunder",
    "right_short_name": "OKC",
    "left_name": "Heat",
    "left_short_name": "MIA",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/14.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/25.png",
    "period_title": "Final",
    "score": "101 - 115",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T01:00:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2694677&utm_id=2694677&utm_campaign=home_liga_partido&utm_content=heat_v_thunder",
    "venue_name": "Paycom Center",
    "venue_state": "OK",
    "venue_country": "USA",
    "left_score": "101",
    "right_score": "115",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2694720",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Bucks v Timberwolves",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Timberwolves",
    "right_short_name": "MIN",
    "left_name": "Bucks",
    "left_short_name": "MIL",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/15.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/16.png",
    "period_title": "Final",
    "score": "103 - 101",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T01:00:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2694720&utm_id=2694720&utm_campaign=home_liga_partido&utm_content=bucks_v_timberwolves",
    "venue_name": "Target Center",
    "venue_state": "MN",
    "venue_country": "USA",
    "left_score": "103",
    "right_score": "101",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2694486",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Kings v Pelicans",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Pelicans",
    "right_short_name": "NOP",
    "left_name": "Kings",
    "left_short_name": "SAC",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/23.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/3.png",
    "period_title": "Final",
    "score": "119 - 111",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T01:00:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2694486&utm_id=2694486&utm_campaign=home_liga_partido&utm_content=kings_v_pelicans",
    "venue_name": "Smoothie King Center",
    "venue_state": "LA",
    "venue_country": "USA",
    "left_score": "119",
    "right_score": "111",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2693783",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Pistons v Bulls",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Bulls",
    "right_short_name": "CHI",
    "left_name": "Pistons",
    "left_short_name": "DET",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/8.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/4.png",
    "period_title": "Final",
    "score": "128 - 110",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T01:00:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2693783&utm_id=2693783&utm_campaign=home_liga_partido&utm_content=pistons_v_bulls",
    "venue_name": "United Center",
    "venue_state": "IL",
    "venue_country": "USA",
    "left_score": "128",
    "right_score": "110",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2694663",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Hawks v Knicks",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Knicks",
    "right_short_name": "NYK",
    "left_name": "Hawks",
    "left_short_name": "ATL",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/1.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/18.png",
    "period_title": "Final",
    "score": "148 - 149",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T00:30:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2694663&utm_id=2694663&utm_campaign=home_liga_partido&utm_content=hawks_v_knicks",
    "venue_name": "Madison Square Garden",
    "venue_state": "NY",
    "venue_country": "USA",
    "left_score": "148",
    "right_score": "149",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2694035",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Cavaliers v Raptors",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Raptors",
    "right_short_name": "TOR",
    "left_name": "Cavaliers",
    "left_short_name": "CLE",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/5.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/28.png",
    "period_title": "Final",
    "score": "131 - 108",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T00:30:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2694035&utm_id=2694035&utm_campaign=home_liga_partido&utm_content=cavaliers_v_raptors",
    "venue_name": "Scotiabank Arena",
    "venue_state": "ON",
    "venue_country": "CAN",
    "left_score": "131",
    "right_score": "108",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2693688",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "76ers v Nets",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Nets",
    "right_short_name": "BKN",
    "left_name": "76ers",
    "left_short_name": "PHI",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/20.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/17.png",
    "period_title": "Final",
    "score": "96 - 100",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T00:30:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2693688&utm_id=2693688&utm_campaign=home_liga_partido&utm_content=76ers_v_nets",
    "venue_name": "Barclays Center",
    "venue_state": "NY",
    "venue_country": "USA",
    "left_score": "96",
    "right_score": "100",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2694418",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Hornets v Magic",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Magic",
    "right_short_name": "ORL",
    "left_name": "Hornets",
    "left_short_name": "CHA",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/5312.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/19.png",
    "period_title": "Final",
    "score": "86 - 102",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T00:00:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2694418&utm_id=2694418&utm_campaign=home_liga_partido&utm_content=hornets_v_magic",
    "venue_name": "Kia Center",
    "venue_state": "FL",
    "venue_country": "USA",
    "left_score": "86",
    "right_score": "102",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2693651",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Spurs v Celtics",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Celtics",
    "right_short_name": "BOS",
    "left_name": "Spurs",
    "left_short_name": "SAS",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/24.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/2.png",
    "period_title": "Final",
    "score": "103 - 116",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-loser",
    "right_class": "clarosports-winner",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T00:00:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2693651&utm_id=2693651&utm_campaign=home_liga_partido&utm_content=spurs_v_celtics",
    "venue_name": "TD Garden",
    "venue_state": "MA",
    "venue_country": "USA",
    "left_score": "103",
    "right_score": "116",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2693807",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Pacers v Wizards",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Wizards",
    "right_short_name": "WAS",
    "left_name": "Pacers",
    "left_short_name": "IND",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/11.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/27.png",
    "period_title": "Final",
    "score": "134 - 130",
    "liga": "NBA",
    "order_league": 1,
    "date": "12 de Feb",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-13T00:00:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2693807&utm_id=2693807&utm_campaign=home_liga_partido&utm_content=pacers_v_wizards",
    "venue_name": "Capital One Arena",
    "venue_state": "DC",
    "venue_country": "USA",
    "left_score": "134",
    "right_score": "130",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  },
  {
    "id_juego": "2694555",
    "id_liga": "",
    "id_torneo": "",
    "game_name": "Grizzlies v Suns",
    "class": "clarosports-finished-game",
    "phase": "",
    "right_name": "Suns",
    "right_short_name": "PHX",
    "left_name": "Grizzlies",
    "left_short_name": "MEM",
    "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/29.png",
    "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/21.png",
    "period_title": "Final",
    "score": "119 - 112",
    "liga": "NBA",
    "order_league": 1,
    "date": "11 de Feb",
    "current": false,
    "left_class": "clarosports-winner",
    "right_class": "clarosports-loser",
    "left_red_card": false,
    "right_red_card": false,
    "utc_date": "2025-02-12T03:00:00Z",
    "should_print_time": false,
    "sport": "BASK",
    "opta_event_url": "https://dev.clarosports.com/partido/?sport=basketball&league=nba&eventId=2694555&utm_id=2694555&utm_campaign=home_liga_partido&utm_content=grizzlies_v_suns",
    "venue_name": "Footprint Center",
    "venue_state": "AZ",
    "venue_country": "USA",
    "left_score": "119",
    "right_score": "112",
    "left_seed": "",
    "right_seed": "",
    "race_results": {
      "laps": 0,
      "raceLength": "",
      "status": "",
      "podium": null,
      "circuit_image": "",
      "race_id": ""
    },
    "strendus_data": {
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": "",
      "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
    },
    "codere_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "caliente_metadata": {
      "event_id": "",
      "left_url_mm": "",
      "right_url_mm": "",
      "middle_url_mm": "",
      "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
      "left_mm": "",
      "right_mm": "",
      "middle_mm": ""
    },
    "baseball_data": {
      "outs": 0,
      "strikes": 0,
      "onBase1": false,
      "onBase2": false,
      "onBase3": false,
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "football_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    },
    "basketball_data": {
      "left_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      },
      "right_stats": {
        "record": {
          "wins": 0,
          "losses": 0,
          "ties": 0,
          "percentage": "",
          "winPercentage": ""
        },
        "linescoreTotals": {}
      }
    }
  }
]

export const NFL2 = [
  {
    "name": "Fútbol Americano",
    "sport_code": "AMFO",
    "print_momios": false,
    "leagues": [
      {
        "name": "National Football League",
        "order": 1,
        "live_game_order": 2,
        "games": [
          {
            "id_juego": "2880090",
            "id_liga": "8",
            "id_torneo": "20250",
            "game_name": "Chargers v 49ers",
            "class": "clarosports-in-progress-game",
            "phase": "Semana 4",
            "right_name": "49ers",
            "right_short_name": "SF",
            "left_name": "Chargers",
            "left_short_name": "LAC",
            "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/357.png",
            "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/359.png",
            "period_title": "Final",
            "score": "23 - 30",
            "liga": "National Football League",
            "order_league": 1,
            "date": "23 de Ago",
            "current": false,
            "left_class": "clarosports-loser",
            "right_class": "clarosports-winner",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-24T00:30:00Z",
            "should_print_time": false,
            "sport": "AMFO",
            "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2880090&utm_id=2880090&utm_campaign=home_hub_partido&utm_content=chargers_v_49ers",
            "venue_name": "Levi's Stadium",
            "venue_state": "CA",
            "venue_country": "USA",
            "left_score": "23",
            "right_score": "30",
            "left_seed": "",
            "right_seed": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "baseball_data": {
              "outs": 0,
              "strikes": 0,
              "onBase1": false,
              "onBase2": false,
              "onBase3": false,
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              }
            },
            "football_data": {
              "last_move": {
                "playerId": 0,
                "period": 3,
                "time": "0:29",
                "down": "2",
                "distance": "12",
                "yardLine": "LAC47",
                "endYardLine": "LAC48",
                "driveId": 33,
                "startPossession": {
                  "teamId": 359
                },
                "endPossession": {
                  "teamId": 359
                }
              },
              "left_stats": {
                "record": {
                  "wins": 2,
                  "losses": 2,
                  "ties": 0,
                  "percentage": ".500",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 13
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 10
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 5,
                    "score": 11
                  }
                ],
                "has_possession": false
              },
              "right_stats": {
                "record": {
                  "wins": 2,
                  "losses": 1,
                  "ties": 0,
                  "percentage": ".667",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 6
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 10
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 14
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 5,
                    "score": 14
                  }
                ],
                "has_possession": true
              }
            },
            "basketball_data": {
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              }
            }
          },
          {
            "id_juego": "2879795",
            "id_liga": "8",
            "id_torneo": "20250",
            "game_name": "Raiders v Cardinals",
            "class": "clarosports-in-progress-game",
            "phase": "Semana 4",
            "right_name": "Cardinals",
            "right_short_name": "Ari",
            "left_name": "Raiders",
            "left_short_name": "LV",
            "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/341.png",
            "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/355.png",
            "period_title": "Final",
            "score": "10 - 20",
            "liga": "National Football League",
            "order_league": 1,
            "date": "23 de Ago",
            "current": false,
            "left_class": "clarosports-loser",
            "right_class": "clarosports-winner",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-24T02:00:00Z",
            "should_print_time": false,
            "sport": "AMFO",
            "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879795&utm_id=2879795&utm_campaign=home_hub_partido&utm_content=raiders_v_cardinals",
            "venue_name": "State Farm Stadium",
            "venue_state": "AZ",
            "venue_country": "USA",
            "left_score": "10",
            "right_score": "20",
            "left_seed": "",
            "right_seed": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "baseball_data": {
              "outs": 0,
              "strikes": 0,
              "onBase1": false,
              "onBase2": false,
              "onBase3": false,
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              }
            },
            "football_data": {
              "last_move": {
                "playerId": 0,
                "period": 2,
                "time": "0:06",
                "down": "2",
                "distance": "10",
                "yardLine": "Ari25",
                "endYardLine": "Ari25",
                "driveId": 23,
                "startPossession": {
                  "teamId": 341
                },
                "endPossession": {
                  "teamId": 341
                }
              },
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 2,
                  "ties": 1,
                  "percentage": ".167",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 7
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 3
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 5,
                    "score": 11
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 6,
                    "score": 14
                  }
                ],
                "has_possession": true
              },
              "right_stats": {
                "record": {
                  "wins": 2,
                  "losses": 1,
                  "ties": 0,
                  "percentage": ".667",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 7
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 3
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 7
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 3
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 5,
                    "score": 1
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 6,
                    "score": 2
                  }
                ],
                "has_possession": false
              }
            },
            "basketball_data": {
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              }
            }
          },
          {
            "id_juego": "2880470",
            "id_liga": "8",
            "id_torneo": "20250",
            "game_name": "Ravens v Commanders",
            "class": "clarosports-finished-game",
            "phase": "Semana 4",
            "right_name": "Commanders",
            "right_short_name": "Was",
            "left_name": "Ravens",
            "left_short_name": "Bal",
            "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/366.png",
            "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/363.png",
            "period_title": "Final",
            "score": "30 - 3",
            "liga": "National Football League",
            "order_league": 1,
            "date": "23 de Ago",
            "current": false,
            "left_class": "clarosports-winner",
            "right_class": "clarosports-loser",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-23T16:00:00Z",
            "should_print_time": false,
            "sport": "AMFO",
            "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2880470&utm_id=2880470&utm_campaign=home_hub_partido&utm_content=ravens_v_commanders",
            "venue_name": "Northwest Stadium",
            "venue_state": "MD",
            "venue_country": "USA",
            "left_score": "30",
            "right_score": "3",
            "left_seed": "",
            "right_seed": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "baseball_data": {
              "outs": 0,
              "strikes": 0,
              "onBase1": false,
              "onBase2": false,
              "onBase3": false,
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              }
            },
            "football_data": {
              "last_move": {
                "playerId": 0,
                "period": 1,
                "time": "0:26",
                "down": "2",
                "distance": "8",
                "yardLine": "Was34",
                "endYardLine": "Was39",
                "driveId": 20,
                "startPossession": {
                  "teamId": 363
                },
                "endPossession": {
                  "teamId": 363
                }
              },
              "left_stats": {
                "record": {
                  "wins": 3,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "1.000",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 7
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 20
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 3
                  }
                ],
                "has_possession": false
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 3,
                  "ties": 0,
                  "percentage": ".000",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 3
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 0
                  }
                ],
                "has_possession": true
              }
            },
            "basketball_data": {
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              }
            }
          },
          {
            "id_juego": "2879587",
            "id_liga": "8",
            "id_torneo": "20250",
            "game_name": "Broncos v Saints",
            "class": "clarosports-finished-game",
            "phase": "Semana 4",
            "right_name": "Saints",
            "right_short_name": "NO",
            "left_name": "Broncos",
            "left_short_name": "Den",
            "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/332.png",
            "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/350.png",
            "period_title": "Final",
            "score": "28 - 19",
            "liga": "National Football League",
            "order_league": 1,
            "date": "23 de Ago",
            "current": false,
            "left_class": "clarosports-winner",
            "right_class": "clarosports-loser",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-23T17:00:00Z",
            "should_print_time": false,
            "sport": "AMFO",
            "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879587&utm_id=2879587&utm_campaign=home_hub_partido&utm_content=broncos_v_saints",
            "venue_name": "Caesars Superdome",
            "venue_state": "LA",
            "venue_country": "USA",
            "left_score": "28",
            "right_score": "19",
            "left_seed": "",
            "right_seed": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "baseball_data": {
              "outs": 0,
              "strikes": 0,
              "onBase1": false,
              "onBase2": false,
              "onBase3": false,
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              }
            },
            "football_data": {
              "last_move": {
                "playerId": 0,
                "period": 4,
                "time": "0:33",
                "down": "2",
                "distance": "11",
                "yardLine": "NO44",
                "endYardLine": "NO45",
                "driveId": 20,
                "startPossession": {
                  "teamId": 332
                },
                "endPossession": {
                  "teamId": 332
                }
              },
              "left_stats": {
                "record": {
                  "wins": 3,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "1.000",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 3
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 13
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 6
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 6
                  }
                ],
                "has_possession": true
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 2,
                  "ties": 1,
                  "percentage": ".167",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 6
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 3
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 10
                  }
                ],
                "has_possession": false
              }
            },
            "basketball_data": {
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              }
            }
          },
          {
            "id_juego": "2879563",
            "id_liga": "8",
            "id_torneo": "20250",
            "game_name": "Colts v Bengals",
            "class": "clarosports-finished-game",
            "phase": "Semana 4",
            "right_name": "Bengals",
            "right_short_name": "Cin",
            "left_name": "Colts",
            "left_short_name": "Ind",
            "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/338.png",
            "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/327.png",
            "period_title": "Final",
            "score": "41 - 14",
            "liga": "National Football League",
            "order_league": 1,
            "date": "23 de Ago",
            "current": false,
            "left_class": "clarosports-winner",
            "right_class": "clarosports-loser",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-23T17:00:00Z",
            "should_print_time": false,
            "sport": "AMFO",
            "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879563&utm_id=2879563&utm_campaign=home_hub_partido&utm_content=colts_v_bengals",
            "venue_name": "Paycor Stadium",
            "venue_state": "OH",
            "venue_country": "USA",
            "left_score": "41",
            "right_score": "14",
            "left_seed": "",
            "right_seed": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "baseball_data": {
              "outs": 0,
              "strikes": 0,
              "onBase1": false,
              "onBase2": false,
              "onBase3": false,
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              }
            },
            "football_data": {
              "last_move": {
                "playerId": 0,
                "period": 2,
                "time": "0:13",
                "down": "1",
                "distance": "10",
                "yardLine": "Ind35",
                "endYardLine": "Ind34",
                "driveId": 20,
                "startPossession": {
                  "teamId": 338
                },
                "endPossession": {
                  "teamId": 338
                }
              },
              "left_stats": {
                "record": {
                  "wins": 1,
                  "losses": 2,
                  "ties": 0,
                  "percentage": ".333",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 10
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 14
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 14
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 3
                  }
                ],
                "has_possession": true
              },
              "right_stats": {
                "record": {
                  "wins": 1,
                  "losses": 2,
                  "ties": 0,
                  "percentage": ".333",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 7
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 7
                  }
                ],
                "has_possession": false
              }
            },
            "basketball_data": {
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              }
            }
          },
          {
            "id_juego": "2879598",
            "id_liga": "8",
            "id_torneo": "20250",
            "game_name": "Rams v Browns",
            "class": "clarosports-finished-game",
            "phase": "Semana 4",
            "right_name": "Browns",
            "right_short_name": "Cle",
            "left_name": "Rams",
            "left_short_name": "LAR",
            "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/343.png",
            "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/329.png",
            "period_title": "Final",
            "score": "17 - 19",
            "liga": "National Football League",
            "order_league": 1,
            "date": "23 de Ago",
            "current": false,
            "left_class": "clarosports-loser",
            "right_class": "clarosports-winner",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-23T17:00:00Z",
            "should_print_time": false,
            "sport": "AMFO",
            "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879598&utm_id=2879598&utm_campaign=home_hub_partido&utm_content=rams_v_browns",
            "venue_name": "Huntington Bank Field",
            "venue_state": "OH",
            "venue_country": "USA",
            "left_score": "17",
            "right_score": "19",
            "left_seed": "",
            "right_seed": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "baseball_data": {
              "outs": 0,
              "strikes": 0,
              "onBase1": false,
              "onBase2": false,
              "onBase3": false,
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              }
            },
            "football_data": {
              "last_move": {
                "playerId": 0,
                "period": 2,
                "time": "0:02",
                "down": "3",
                "distance": "7",
                "yardLine": "LAR19",
                "endYardLine": "LAR0",
                "driveId": 22,
                "startPossession": {
                  "teamId": 329
                },
                "endPossession": {
                  "teamId": 329
                }
              },
              "left_stats": {
                "record": {
                  "wins": 2,
                  "losses": 1,
                  "ties": 0,
                  "percentage": ".667",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 7
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 3
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 7
                  }
                ],
                "has_possession": false
              },
              "right_stats": {
                "record": {
                  "wins": 3,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "1.000",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 7
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 9
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 3
                  }
                ],
                "has_possession": true
              }
            },
            "basketball_data": {
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              }
            }
          },
          {
            "id_juego": "2879797",
            "id_liga": "8",
            "id_torneo": "20250",
            "game_name": "Texans v Lions",
            "class": "clarosports-finished-game",
            "phase": "Semana 4",
            "right_name": "Lions",
            "right_short_name": "Det",
            "left_name": "Texans",
            "left_short_name": "Hou",
            "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/325.png",
            "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/334.png",
            "period_title": "Final",
            "score": "26 - 7",
            "liga": "National Football League",
            "order_league": 1,
            "date": "23 de Ago",
            "current": false,
            "left_class": "clarosports-winner",
            "right_class": "clarosports-loser",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-23T17:00:00Z",
            "should_print_time": false,
            "sport": "AMFO",
            "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879797&utm_id=2879797&utm_campaign=home_hub_partido&utm_content=texans_v_lions",
            "venue_name": "Ford Field",
            "venue_state": "MI",
            "venue_country": "USA",
            "left_score": "26",
            "right_score": "7",
            "left_seed": "",
            "right_seed": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "baseball_data": {
              "outs": 0,
              "strikes": 0,
              "onBase1": false,
              "onBase2": false,
              "onBase3": false,
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              }
            },
            "football_data": {
              "last_move": {
                "playerId": 0,
                "period": 4,
                "time": "0:37",
                "down": "2",
                "distance": "11",
                "yardLine": "Det49",
                "endYardLine": "Hou50",
                "driveId": 17,
                "startPossession": {
                  "teamId": 325
                },
                "endPossession": {
                  "teamId": 325
                }
              },
              "left_stats": {
                "record": {
                  "wins": 2,
                  "losses": 1,
                  "ties": 0,
                  "percentage": ".667",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 3
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 13
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 10
                  }
                ],
                "has_possession": true
              },
              "right_stats": {
                "record": {
                  "wins": 1,
                  "losses": 3,
                  "ties": 0,
                  "percentage": ".250",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 7
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 0
                  }
                ],
                "has_possession": false
              }
            },
            "basketball_data": {
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              }
            }
          },
          {
            "id_juego": "2879576",
            "id_liga": "8",
            "id_torneo": "20250",
            "game_name": "Seahawks v Packers",
            "class": "clarosports-finished-game",
            "phase": "Semana 4",
            "right_name": "Packers",
            "right_short_name": "GB",
            "left_name": "Seahawks",
            "left_short_name": "Sea",
            "left_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/361.png",
            "right_image": "https://widgets-shared-static.stats.com/logos/40x40/football/nfl/335.png",
            "period_title": "Final",
            "score": "7 - 20",
            "liga": "National Football League",
            "order_league": 1,
            "date": "23 de Ago",
            "current": false,
            "left_class": "clarosports-loser",
            "right_class": "clarosports-winner",
            "left_red_card": false,
            "right_red_card": false,
            "utc_date": "2025-08-23T20:00:00Z",
            "should_print_time": false,
            "sport": "AMFO",
            "opta_event_url": "https://dev.clarosports.com/partido/?sport=football&league=nfl&eventId=2879576&utm_id=2879576&utm_campaign=home_hub_partido&utm_content=seahawks_v_packers",
            "venue_name": "Lambeau Field",
            "venue_state": "WI",
            "venue_country": "USA",
            "left_score": "7",
            "right_score": "20",
            "left_seed": "",
            "right_seed": "",
            "race_results": {
              "laps": 0,
              "raceLength": "",
              "status": "",
              "podium": null,
              "circuit_image": "",
              "race_id": ""
            },
            "strendus_data": {
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": "",
              "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
            },
            "codere_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "caliente_metadata": {
              "event_id": "",
              "left_url_mm": "",
              "right_url_mm": "",
              "middle_url_mm": "",
              "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
              "left_mm": "",
              "right_mm": "",
              "middle_mm": ""
            },
            "baseball_data": {
              "outs": 0,
              "strikes": 0,
              "onBase1": false,
              "onBase2": false,
              "onBase3": false,
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "start_pitcher": {
                  "type": {
                    "name": "",
                    "typeId": 0
                  },
                  "player": {
                    "playerId": 0,
                    "firstName": "",
                    "lastName": "",
                    "uniform": ""
                  },
                  "wins": 0,
                  "losses": 0,
                  "earnedRunAverage": "",
                  "image": ""
                }
              }
            },
            "football_data": {
              "last_move": {
                "playerId": 0,
                "period": 4,
                "time": "0:38",
                "down": "3",
                "distance": "12",
                "yardLine": "GB29",
                "endYardLine": "GB28",
                "driveId": 28,
                "startPossession": {
                  "teamId": 335
                },
                "endPossession": {
                  "teamId": 335
                }
              },
              "left_stats": {
                "record": {
                  "wins": 1,
                  "losses": 1,
                  "ties": 1,
                  "percentage": ".500",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 7
                  }
                ],
                "has_possession": false
              },
              "right_stats": {
                "record": {
                  "wins": 2,
                  "losses": 1,
                  "ties": 0,
                  "percentage": ".667",
                  "winPercentage": ""
                },
                "linescores": [
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 1,
                    "score": 10
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 2,
                    "score": 10
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 3,
                    "score": 0
                  },
                  {
                    "runs": 0,
                    "hits": 0,
                    "errors": 0,
                    "period": 4,
                    "score": 0
                  }
                ],
                "has_possession": true
              }
            },
            "basketball_data": {
              "left_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              },
              "right_stats": {
                "record": {
                  "wins": 0,
                  "losses": 0,
                  "ties": 0,
                  "percentage": "",
                  "winPercentage": ""
                },
                "linescoreTotals": {
                  "runs": 0,
                  "hits": 0,
                  "errors": 0,
                  "period": 0,
                  "score": 0
                },
                "linescore": null
              }
            }
          }
        ]
      }
    ]
  }
]

export const F1 = {
  "name": "Motor",
  "sport_code": "MTR",
  "print_momios": false,
  "leagues": [
    {
      "name": "Fia formula E",
      "order": 1,
      "live_game_order": 2,
      "games": [{
  "id_juego": "4pqm1uh51lj0u08uc04eaej8",
  "id_liga": "",
  "id_torneo": "",
  "game_name": "Dutch Grand Prix / Friday practice",
  "class": "clarosports-next-game",
  "phase": "",
  "right_name": "",
  "right_short_name": "",
  "left_name": "",
  "left_short_name": "",
  "left_image": "",
  "right_image": "",
  "period_title": "04:30",
  "score": "",
  "liga": "FIA F1 World Championship 2025",
  "order_league": 1,
  "date": "29 de Ago",
  "current": true,
  "left_class": "",
  "right_class": "",
  "left_red_card": false,
  "right_red_card": false,
  "utc_date": "2025-08-29T10:30:00Z",
  "should_print_time": true,
  "sport": "MTR",
  "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=9l7ordv5sqnck0498ityvh444&utm_id=4pqm1uh51lj0u08uc04eaej8&utm_campaign=home_liga_partido&utm_content=dutch_grand_prix",
  "venue_name": "Circuit Zandvoort",
  "venue_state": "Zandvoort",
  "venue_country": "Netherlands",
  "left_score": "",
  "right_score": "",
  "left_seed": "",
  "right_seed": "",
  "left_tenis_score": null,
  "right_tenis_score": null,
  "tenis_fase": "",
  "race_results": {
    "laps": 0,
    "raceLength": "",
    "status": "",
    "podium": null,
    "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Circuit_Zandvoort.svg",
    "race_id": ""
  },
  "strendus_data": {
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": "",
    "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
  },
  "codere_metadata": {
    "event_id": "",
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": ""
  },
  "caliente_metadata": {
    "event_id": "",
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": ""
  }
},
{
  "id_juego": "9bv2jh33f28jr26qtwgolbmc",
  "id_liga": "",
  "id_torneo": "",
  "game_name": "Dutch Grand Prix / Friday practice 2",
  "class": "clarosports-next-game",
  "phase": "",
  "right_name": "",
  "right_short_name": "",
  "left_name": "",
  "left_short_name": "",
  "left_image": "",
  "right_image": "",
  "period_title": "08:00",
  "score": "",
  "liga": "FIA F1 World Championship 2025",
  "order_league": 1,
  "date": "29 de Ago",
  "current": true,
  "left_class": "",
  "right_class": "",
  "left_red_card": false,
  "right_red_card": false,
  "utc_date": "2025-08-29T14:00:00Z",
  "should_print_time": true,
  "sport": "MTR",
  "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=9l7ordv5sqnck0498ityvh444&utm_id=9bv2jh33f28jr26qtwgolbmc&utm_campaign=home_liga_partido&utm_content=dutch_grand_prix",
  "venue_name": "Circuit Zandvoort",
  "venue_state": "Zandvoort",
  "venue_country": "Netherlands",
  "left_score": "",
  "right_score": "",
  "left_seed": "",
  "right_seed": "",
  "left_tenis_score": null,
  "right_tenis_score": null,
  "tenis_fase": "",
  "race_results": {
    "laps": 0,
    "raceLength": "",
    "status": "",
    "podium": null,
    "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Circuit_Zandvoort.svg",
    "race_id": ""
  },
  "strendus_data": {
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": "",
    "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
  },
  "codere_metadata": {
    "event_id": "",
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": ""
  },
  "caliente_metadata": {
    "event_id": "",
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": ""
  }
},
{
  "id_juego": "1wk9z09wu4em60posm46hhjis",
  "id_liga": "",
  "id_torneo": "",
  "game_name": "Dutch Grand Prix / Saturday practice",
  "class": "clarosports-next-game",
  "phase": "",
  "right_name": "",
  "right_short_name": "",
  "left_name": "",
  "left_short_name": "",
  "left_image": "",
  "right_image": "",
  "period_title": "03:30",
  "score": "",
  "liga": "FIA F1 World Championship 2025",
  "order_league": 1,
  "date": "30 de Ago",
  "current": true,
  "left_class": "",
  "right_class": "",
  "left_red_card": false,
  "right_red_card": false,
  "utc_date": "2025-08-30T09:30:00Z",
  "should_print_time": true,
  "sport": "MTR",
  "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=9l7ordv5sqnck0498ityvh444&utm_id=1wk9z09wu4em60posm46hhjis&utm_campaign=home_liga_partido&utm_content=dutch_grand_prix",
  "venue_name": "Circuit Zandvoort",
  "venue_state": "Zandvoort",
  "venue_country": "Netherlands",
  "left_score": "",
  "right_score": "",
  "left_seed": "",
  "right_seed": "",
  "left_tenis_score": null,
  "right_tenis_score": null,
  "tenis_fase": "",
  "race_results": {
    "laps": 0,
    "raceLength": "",
    "status": "",
    "podium": null,
    "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Circuit_Zandvoort.svg",
    "race_id": ""
  },
  "strendus_data": {
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": "",
    "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
  },
  "codere_metadata": {
    "event_id": "",
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": ""
  },
  "caliente_metadata": {
    "event_id": "",
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": ""
  }
},
{
  "id_juego": "22op31roxa330ymu8fpns1kic",
  "id_liga": "",
  "id_torneo": "",
  "game_name": "Dutch Grand Prix / 1st Qualification",
  "class": "clarosports-in-progress-game",
  "phase": "",
  "right_name": "",
  "right_short_name": "",
  "left_name": "",
  "left_short_name": "",
  "left_image": "",
  "right_image": "",
  "period_title": "07:00",
  "score": "",
  "liga": "FIA F1 World Championship 2025",
  "order_league": 1,
  "date": "30 de Ago",
  "current": true,
  "left_class": "",
  "right_class": "",
  "left_red_card": false,
  "right_red_card": false,
  "utc_date": "2025-08-30T13:00:00Z",
  "should_print_time": true,
  "sport": "MTR",
  "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=9l7ordv5sqnck0498ityvh444&utm_id=22op31roxa330ymu8fpns1kic&utm_campaign=home_liga_partido&utm_content=dutch_grand_prix",
  "venue_name": "Circuit Zandvoort",
  "venue_state": "Zandvoort",
  "venue_country": "Netherlands",
  "left_score": "",
  "right_score": "",
  "left_seed": "",
  "right_seed": "",
  "left_tenis_score": null,
  "right_tenis_score": null,
  "tenis_fase": "",
  "race_results": {
    "laps": 0,
    "raceLength": "",
    "status": "",
    "podium": [
      {
        "firstName": "Lando",
        "lastName": "Norris",
        "points": "0.000",
        "nationality": "",
        "carNumber": 0,
        "team": "McLaren",
        "timeHours": 0,
        "timeMinutes": 0,
        "timeSeconds": 0,
        "timeMilliseconds": 0,
        "timeDiference": "+0.000s",
        "timeString": "00:01:10.278",
        "nationalityCode": "GBR"
      },
      {
        "firstName": "Oscar",
        "lastName": "Piastri",
        "points": "0.000",
        "nationality": "",
        "carNumber": 0,
        "team": "McLaren",
        "timeHours": 0,
        "timeMinutes": 0,
        "timeSeconds": 0,
        "timeMilliseconds": 0,
        "timeDiference": "+0.292s",
        "timeString": "00:01:10.570",
        "nationalityCode": "AUS"
      },
      {
        "firstName": "Lance",
        "lastName": "Stroll",
        "points": "0.000",
        "nationality": "",
        "carNumber": 0,
        "team": "Aston Martin Aramco",
        "timeHours": 0,
        "timeMinutes": 0,
        "timeSeconds": 0,
        "timeMilliseconds": 0,
        "timeDiference": "+0.501s",
        "timeString": "00:01:10.779",
        "nationalityCode": "CAN"
      }
    ],
    "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Marina_Bay_Street_Circuit.svg",
    "race_id": ""
  },
  "strendus_data": {
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": "",
    "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
  },
  "codere_metadata": {
    "event_id": "",
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": ""
  },
  "caliente_metadata": {
    "event_id": "",
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": ""
  }
},
{
  "id_juego": "27fj6lwv9ai0c4ixtwgmdn6l0",
  "id_liga": "",
  "id_torneo": "",
  "game_name": "Dutch Grand Prix / 2nd Qualification",
  "class": "clarosports-next-game",
  "phase": "",
  "right_name": "",
  "right_short_name": "",
  "left_name": "",
  "left_short_name": "",
  "left_image": "",
  "right_image": "",
  "period_title": "07:25",
  "score": "",
  "liga": "FIA F1 World Championship 2025",
  "order_league": 1,
  "date": "30 de Ago",
  "current": true,
  "left_class": "",
  "right_class": "",
  "left_red_card": false,
  "right_red_card": false,
  "utc_date": "2025-08-30T13:25:00Z",
  "should_print_time": true,
  "sport": "MTR",
  "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=9l7ordv5sqnck0498ityvh444&utm_id=27fj6lwv9ai0c4ixtwgmdn6l0&utm_campaign=home_liga_partido&utm_content=dutch_grand_prix",
  "venue_name": "Circuit Zandvoort",
  "venue_state": "Zandvoort",
  "venue_country": "Netherlands",
  "left_score": "",
  "right_score": "",
  "left_seed": "",
  "right_seed": "",
  "left_tenis_score": null,
  "right_tenis_score": null,
  "tenis_fase": "",
  "race_results": {
    "laps": 0,
    "raceLength": "",
    "status": "",
    "podium": null,
    "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Marina_Bay_Street_Circuit.svg",
    "race_id": ""
  },
  "strendus_data": {
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": "",
    "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
  },
  "codere_metadata": {
    "event_id": "",
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": ""
  },
  "caliente_metadata": {
    "event_id": "",
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": ""
  }
},
{
  "id_juego": "2dx21q4iefe7vvyxlgl1yvims",
  "id_liga": "",
  "id_torneo": "",
  "game_name": "Dutch Grand Prix / 3rd Qualification",
  "class": "clarosports-next-game",
  "phase": "",
  "right_name": "",
  "right_short_name": "",
  "left_name": "",
  "left_short_name": "",
  "left_image": "",
  "right_image": "",
  "period_title": "07:48",
  "score": "",
  "liga": "FIA F1 World Championship 2025",
  "order_league": 1,
  "date": "30 de Ago",
  "current": true,
  "left_class": "",
  "right_class": "",
  "left_red_card": false,
  "right_red_card": false,
  "utc_date": "2025-08-30T13:48:00Z",
  "should_print_time": true,
  "sport": "MTR",
  "opta_event_url": "https://dev.clarosports.com/hub-estadisticas/motor/f1/carrera/?competition=1m5x4n07f2kqkiczebja5etiq&season=42pjmtz8i21rtly3szwi4l1ck&race=9l7ordv5sqnck0498ityvh444&utm_id=2dx21q4iefe7vvyxlgl1yvims&utm_campaign=home_liga_partido&utm_content=dutch_grand_prix",
  "venue_name": "Circuit Zandvoort",
  "venue_state": "Zandvoort",
  "venue_country": "Netherlands",
  "left_score": "",
  "right_score": "",
  "left_seed": "",
  "right_seed": "",
  "left_tenis_score": null,
  "right_tenis_score": null,
  "tenis_fase": "",
  "race_results": {
    "laps": 0,
    "raceLength": "",
    "status": "",
    "podium": null,
    "circuit_image": "https://dev-cdn.amxinfra.com/hub/images/pistasF1/Circuit_Zandvoort.svg",
    "race_id": ""
  },
  "strendus_data": {
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": "",
    "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
  },
  "codere_metadata": {
    "event_id": "",
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": ""
  },
  "caliente_metadata": {
    "event_id": "",
    "left_url_mm": "",
    "right_url_mm": "",
    "middle_url_mm": "",
    "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
    "left_mm": "",
    "right_mm": "",
    "middle_mm": ""
  }
}]
    }
  ]
}

export const TEN = {
  "name": "Tenis",
  "sport_code": "TNS",
  "print_momios": false,
  "leagues": [
    {
      "name": "WTA Tour",
      "order": 1,
      "live_game_order": 2,
      "games": [
        {
          "id_juego": "2914791",
          "id_liga": "1",
          "id_torneo": "",
          "game_name": "Thunder v Pistons",
          "class": "clarosports-next-game",
          "phase": "Temporada Regular",
          "right_name": "JANNIK SINNER",
          "right_short_name": "COL",
          "left_name": "CARLOS ALCARAZ",
          "left_short_name": "ESP",
          "left_image": "ITA",
          "right_image": "ESP",
          "period_title": "17:00",
          "score": "VS",
          "liga": "National Basketball Assoc.",
          "order_league": 1,
          "date": "25 de Feb",
          "current": true,
          "left_class": "clarosports-draw",
          "right_class": "clarosports-draw",
          "left_red_card": false,
          "right_red_card": false,
          "utc_date": "2026-02-26T00:00:00Z",
          "should_print_time": true,
          "sport": "TNS",
          "opta_event_url": "https://www.clarosports.com/partido/?sport=basketball&league=nba&eventId=2914791&utm_id=2914791&utm_campaign=home_hub_partido&utm_content=thunder_v_pistons",
          "venue_name": "Little Caesars Arena",
          "venue_state": "MI",
          "venue_country": "USA",
          "left_score": "0",
          "right_score": "0",
          "race_results": {},
          "strendus_data": {},
          "codere_metadata": {},
          "caliente_metadata": {},
          "streaming_data": {},
          "baseball_data": {},
          "football_data": {},
          "basketball_data": {},
          "tenis_data": {
            "tenis_fase": "Primera Fase",
            "left_stats": {
              "left_seed": "",
              "first_server": false
            },
            "right_stats": {
              "right_seed": "",
              "first_server": false
            }
          }
        },
        {
          "id_juego": "2914498",
          "id_liga": "1",
          "id_torneo": "",
          "game_name": "Spurs v Raptors",
          "class": "clarosports-in-progress-game",
          "phase": "Temporada Regular",
          "right_name": "MARIA DEL CARMEN PALACIOS",
          "right_short_name": "TOR",
          "left_name": "PEDRO JOSE MARTINEZ",
          "left_short_name": "SAS",
          "left_image": "ARG",
          "right_image": "URU",
          "period_title": "17:30",
          "score": "VS",
          "liga": "National Basketball Assoc.",
          "order_league": 1,
          "date": "25 de Feb",
          "current": true,
          "left_class": "clarosports-draw",
          "right_class": "clarosports-draw",
          "left_red_card": false,
          "right_red_card": false,
          "utc_date": "2026-02-26T00:30:00Z",
          "should_print_time": true,
          "sport": "BASK",
          "opta_event_url": "https://www.clarosports.com/partido/?sport=basketball&league=nba&eventId=2914498&utm_id=2914498&utm_campaign=home_hub_partido&utm_content=spurs_v_raptors",
          "venue_name": "Scotiabank Arena",
          "venue_state": "ON",
          "venue_country": "CAN",
          "left_score": "0",
          "right_score": "0",
          "race_results": {
            "laps": 0,
            "raceLength": "",
            "status": "",
            "podium": null,
            "circuit_image": "",
            "race_id": ""
          },
          "strendus_data": {
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": "",
            "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
          },
          "codere_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "caliente_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "streaming_data": {
            "has_streaming": false,
            "url": "",
            "provider": ""
          },
          "baseball_data": {
            "outs": 0,
            "strikes": 0,
            "onBase1": false,
            "onBase2": false,
            "onBase3": false,
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "",
                  "typeId": 0
                },
                "player": {
                  "playerId": 0,
                  "firstName": "",
                  "lastName": "",
                  "uniform": ""
                },
                "wins": 0,
                "losses": 0,
                "earnedRunAverage": "",
                "image": ""
              }
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "",
                  "typeId": 0
                },
                "player": {
                  "playerId": 0,
                  "firstName": "",
                  "lastName": "",
                  "uniform": ""
                },
                "wins": 0,
                "losses": 0,
                "earnedRunAverage": "",
                "image": ""
              }
            }
          },
          "football_data": {
            "last_move": {
              "playerId": 0,
              "period": 0,
              "time": "",
              "down": "",
              "distance": "",
              "yardLine": "",
              "endYardLine": "",
              "driveId": 0,
              "startPossession": {
                "teamId": 0
              },
              "endPossession": {
                "teamId": 0
              }
            },
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            }
          },
          "basketball_data": {
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            }
          },
          "tenis_data": {
            "left_stats": {
              "left_seed": "",
              "first_server": false,
              "left_tenis_score": [{
                "tiebreak": 2,
                "is_higher": true,
                "score": 2
              },
              {
                "tiebreak": 4,
                "is_higher": true,
                "score": 2
              },
              {
                "tiebreak": 1,
                "is_higher": false,
                "score": 2
              },
              {
                "tiebreak": 7,
                "is_higher": true,
                "score": 2
              },
              {
                "tiebreak": 8,
                "is_higher": true,
                "score": 2
              }
              ]
            },
            "right_stats": {
              "right_seed": "",
              "first_server": false,
              "right_tenis_score": [{
                "tiebreak": 0,
                "is_higher": false,
                "score": 1
              },
              {
                "tiebreak": 2,
                "is_higher": true,
                "score": 2
              },
              {
                "tiebreak": 4,
                "is_higher": true,
                "score": 2
              }, {
                "tiebreak": 10,
                "is_higher": true,
                "score": 2
              }, {
                "tiebreak": 9,
                "is_higher": true,
                "score": 2
              }
              ]
            }
          }
        },
        {
          "id_juego": "2915194",
          "id_liga": "1",
          "id_torneo": "",
          "game_name": "Warriors v Grizzlies",
          "class": "clarosports-finished-game",
          "phase": "Temporada Regular",
          "right_name": "Martin Martinez",
          "right_short_name": "MEM",
          "left_name": "Pablo Perez",
          "left_short_name": "GSW",
          "left_image": "PER",
          "right_image": "VEN",
          "period_title": "Finalizado",
          "score": "VS",
          "liga": "National Basketball Assoc.",
          "order_league": 1,
          "date": "25 de Feb",
          "current": true,
          "left_class": "clarosports-draw",
          "right_class": "clarosports-draw",
          "left_red_card": false,
          "right_red_card": false,
          "utc_date": "2026-02-26T00:30:00Z",
          "should_print_time": true,
          "sport": "BASK",
          "opta_event_url": "https://www.clarosports.com/partido/?sport=basketball&league=nba&eventId=2915194&utm_id=2915194&utm_campaign=home_hub_partido&utm_content=warriors_v_grizzlies",
          "venue_name": "FedExForum",
          "venue_state": "TN",
          "venue_country": "USA",
          "left_score": "0",
          "right_score": "0",
          "race_results": {
            "laps": 0,
            "raceLength": "",
            "status": "",
            "podium": null,
            "circuit_image": "",
            "race_id": ""
          },
          "strendus_data": {
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": "",
            "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
          },
          "codere_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "caliente_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "streaming_data": {
            "has_streaming": false,
            "url": "",
            "provider": ""
          },
          "baseball_data": {
            "outs": 0,
            "strikes": 0,
            "onBase1": false,
            "onBase2": false,
            "onBase3": false,
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "",
                  "typeId": 0
                },
                "player": {
                  "playerId": 0,
                  "firstName": "",
                  "lastName": "",
                  "uniform": ""
                },
                "wins": 0,
                "losses": 0,
                "earnedRunAverage": "",
                "image": ""
              }
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "",
                  "typeId": 0
                },
                "player": {
                  "playerId": 0,
                  "firstName": "",
                  "lastName": "",
                  "uniform": ""
                },
                "wins": 0,
                "losses": 0,
                "earnedRunAverage": "",
                "image": ""
              }
            }
          },
          "football_data": {
            "last_move": {
              "playerId": 0,
              "period": 0,
              "time": "",
              "down": "",
              "distance": "",
              "yardLine": "",
              "endYardLine": "",
              "driveId": 0,
              "startPossession": {
                "teamId": 0
              },
              "endPossession": {
                "teamId": 0
              }
            },
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            }
          },
          "basketball_data": {
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            }
          },
          "tenis_data": {
            "tenis_fase": "Primera Fase",
            "left_stats": {
              "left_seed": "",
              "first_server": false,
              "tenis_fase": "Primera Fase",
              "left_tenis_score": [{
                "tiebreak": 2,
                "is_higher": true,
                "score": 2
              },
              {
                "tiebreak": 4,
                "is_higher": true,
                "score": 2
              },
              {
                "tiebreak": 1,
                "is_higher": false,
                "score": 2
              },
              {
                "tiebreak": 7,
                "is_higher": true,
                "score": 2
              },
              {
                "tiebreak": 8,
                "is_higher": true,
                "score": 2
              }
              ]
            },
            "right_stats": {
              "right_seed": "",
              "first_server": false,
              "tenis_fase": "Primera Fase",
              "right_tenis_score": [{
                "tiebreak": 0,
                "is_higher": false,
                "score": 1
              },
              {
                "tiebreak": 2,
                "is_higher": true,
                "score": 2
              },
              {
                "tiebreak": 4,
                "is_higher": true,
                "score": 2
              }, {
                "tiebreak": 10,
                "is_higher": true,
                "score": 2
              }, {
                "tiebreak": 9,
                "is_higher": true,
                "score": 2
              }
              ]
            }
          }
        },
        {
          "id_juego": "2914982",
          "id_liga": "1",
          "id_torneo": "",
          "game_name": "Kings v Rockets",
          "class": "clarosports-error-game",
          "phase": "Temporada Regular",
          "right_name": "santiago sandoval",
          "right_short_name": "HOU",
          "left_name": "Maria del carmen martinez",
          "left_short_name": "SAC",
          "left_image": "MEX",
          "right_image": "USA",
          "period_title": "pospuesto",
          "score": "VS",
          "liga": "National Basketball Assoc.",
          "order_league": 1,
          "date": "25 de Feb",
          "current": true,
          "left_class": "clarosports-draw",
          "right_class": "clarosports-draw",
          "left_red_card": false,
          "right_red_card": false,
          "utc_date": "2026-02-26T01:00:00Z",
          "should_print_time": true,
          "sport": "BASK",
          "opta_event_url": "https://www.clarosports.com/partido/?sport=basketball&league=nba&eventId=2914982&utm_id=2914982&utm_campaign=home_hub_partido&utm_content=kings_v_rockets",
          "venue_name": "Toyota Center",
          "venue_state": "TX",
          "venue_country": "USA",
          "left_score": "0",
          "right_score": "0",
          "race_results": {
            "laps": 0,
            "raceLength": "",
            "status": "",
            "podium": null,
            "circuit_image": "",
            "race_id": ""
          },
          "strendus_data": {
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": "",
            "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
          },
          "codere_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "caliente_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "streaming_data": {
            "has_streaming": false,
            "url": "",
            "provider": ""
          },
          "baseball_data": {
            "outs": 0,
            "strikes": 0,
            "onBase1": false,
            "onBase2": false,
            "onBase3": false,
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "",
                  "typeId": 0
                },
                "player": {
                  "playerId": 0,
                  "firstName": "",
                  "lastName": "",
                  "uniform": ""
                },
                "wins": 0,
                "losses": 0,
                "earnedRunAverage": "",
                "image": ""
              }
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "",
                  "typeId": 0
                },
                "player": {
                  "playerId": 0,
                  "firstName": "",
                  "lastName": "",
                  "uniform": ""
                },
                "wins": 0,
                "losses": 0,
                "earnedRunAverage": "",
                "image": ""
              }
            }
          },
          "football_data": {
            "last_move": {
              "playerId": 0,
              "period": 0,
              "time": "",
              "down": "",
              "distance": "",
              "yardLine": "",
              "endYardLine": "",
              "driveId": 0,
              "startPossession": {
                "teamId": 0
              },
              "endPossession": {
                "teamId": 0
              }
            },
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            }
          },
          "basketball_data": {
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            }
          },
          "tenis_data": {
            "left_stats": {
              "left_seed": "",
              "first_server": false
            },
            "right_stats": {
              "right_seed": "",
              "first_server": false
            }
          }
        },
        {
          "id_juego": "2915184",
          "id_liga": "1",
          "id_torneo": "",
          "game_name": "Cavaliers v Bucks",
          "class": "clarosports-next-game",
          "phase": "Temporada Regular",
          "right_name": "Bucks",
          "right_short_name": "MIL",
          "left_name": "Cavaliers",
          "left_short_name": "CLE",
          "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/5.png",
          "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/15.png",
          "period_title": "18:00",
          "score": "VS",
          "liga": "National Basketball Assoc.",
          "order_league": 1,
          "date": "25 de Feb",
          "current": true,
          "left_class": "clarosports-draw",
          "right_class": "clarosports-draw",
          "left_red_card": false,
          "right_red_card": false,
          "utc_date": "2026-02-26T01:00:00Z",
          "should_print_time": true,
          "sport": "BASK",
          "opta_event_url": "https://www.clarosports.com/partido/?sport=basketball&league=nba&eventId=2915184&utm_id=2915184&utm_campaign=home_hub_partido&utm_content=cavaliers_v_bucks",
          "venue_name": "Fiserv Forum",
          "venue_state": "WI",
          "venue_country": "USA",
          "left_score": "0",
          "right_score": "0",
          "race_results": {
            "laps": 0,
            "raceLength": "",
            "status": "",
            "podium": null,
            "circuit_image": "",
            "race_id": ""
          },
          "strendus_data": {
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": "",
            "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
          },
          "codere_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "caliente_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "streaming_data": {
            "has_streaming": false,
            "url": "",
            "provider": ""
          },
          "baseball_data": {
            "outs": 0,
            "strikes": 0,
            "onBase1": false,
            "onBase2": false,
            "onBase3": false,
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "",
                  "typeId": 0
                },
                "player": {
                  "playerId": 0,
                  "firstName": "",
                  "lastName": "",
                  "uniform": ""
                },
                "wins": 0,
                "losses": 0,
                "earnedRunAverage": "",
                "image": ""
              }
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "",
                  "typeId": 0
                },
                "player": {
                  "playerId": 0,
                  "firstName": "",
                  "lastName": "",
                  "uniform": ""
                },
                "wins": 0,
                "losses": 0,
                "earnedRunAverage": "",
                "image": ""
              }
            }
          },
          "football_data": {
            "last_move": {
              "playerId": 0,
              "period": 0,
              "time": "",
              "down": "",
              "distance": "",
              "yardLine": "",
              "endYardLine": "",
              "driveId": 0,
              "startPossession": {
                "teamId": 0
              },
              "endPossession": {
                "teamId": 0
              }
            },
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            }
          },
          "basketball_data": {
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            }
          },
          "tenis_data": {
            "left_stats": {
              "left_seed": "",
              "first_server": false
            },
            "right_stats": {
              "right_seed": "",
              "first_server": false
            }
          }
        },
        {
          "id_juego": "2914884",
          "id_liga": "1",
          "id_torneo": "",
          "game_name": "Celtics v Nuggets",
          "class": "clarosports-next-game",
          "phase": "Temporada Regular",
          "right_name": "Nuggets",
          "right_short_name": "DEN",
          "left_name": "Celtics",
          "left_short_name": "BOS",
          "left_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/2.png",
          "right_image": "https://widgets-shared-static.stats.com/logos/40x40/basketball/nba/7.png",
          "period_title": "20:00",
          "score": "VS",
          "liga": "National Basketball Assoc.",
          "order_league": 1,
          "date": "25 de Feb",
          "current": true,
          "left_class": "clarosports-draw",
          "right_class": "clarosports-draw",
          "left_red_card": false,
          "right_red_card": false,
          "utc_date": "2026-02-26T03:00:00Z",
          "should_print_time": true,
          "sport": "BASK",
          "opta_event_url": "https://www.clarosports.com/partido/?sport=basketball&league=nba&eventId=2914884&utm_id=2914884&utm_campaign=home_hub_partido&utm_content=celtics_v_nuggets",
          "venue_name": "Ball Arena",
          "venue_state": "CO",
          "venue_country": "USA",
          "left_score": "0",
          "right_score": "0",
          "race_results": {
            "laps": 0,
            "raceLength": "",
            "status": "",
            "podium": null,
            "circuit_image": "",
            "race_id": ""
          },
          "strendus_data": {
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": "",
            "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs&utm_source=mc&utm_medium=dp&utm_campaign=mc_d_cpc_r_estadtcs"
          },
          "codere_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "caliente_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "https://online.caliente.mx/promoRedirect?member=clarosports&campaign=DEFAULT&channel=DEFAULT&zone=54623980&lp=0&var1=hpl",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "streaming_data": {
            "has_streaming": false,
            "url": "",
            "provider": ""
          },
          "baseball_data": {
            "outs": 0,
            "strikes": 0,
            "onBase1": false,
            "onBase2": false,
            "onBase3": false,
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "",
                  "typeId": 0
                },
                "player": {
                  "playerId": 0,
                  "firstName": "",
                  "lastName": "",
                  "uniform": ""
                },
                "wins": 0,
                "losses": 0,
                "earnedRunAverage": "",
                "image": ""
              }
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "",
                  "typeId": 0
                },
                "player": {
                  "playerId": 0,
                  "firstName": "",
                  "lastName": "",
                  "uniform": ""
                },
                "wins": 0,
                "losses": 0,
                "earnedRunAverage": "",
                "image": ""
              }
            }
          },
          "football_data": {
            "last_move": {
              "playerId": 0,
              "period": 0,
              "time": "",
              "down": "",
              "distance": "",
              "yardLine": "",
              "endYardLine": "",
              "driveId": 0,
              "startPossession": {
                "teamId": 0
              },
              "endPossession": {
                "teamId": 0
              }
            },
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            }
          },
          "basketball_data": {
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            }
          },
          "tenis_data": {
            "left_stats": {
              "left_seed": "",
              "first_server": false
            },
            "right_stats": {
              "right_seed": "",
              "first_server": false
            }
          }
        }
      ]
    }
  ]
}

export const BASE = {
  "name": "Béisbol",
  "sport_code": "BASE",
  "print_momios": false,
  "leagues": [
    {
      "name": "Major League Baseball",
      "order": 1,
      "live_game_order": 2,
      "games": [
        {
          "id_juego": "2914252",
          "id_liga": "7",
          "id_torneo": "20252",
          "game_name": "Dodgers v Blue Jays",
          "class": "clarosports-finished-game",
          "phase": "Postemporada",
          "right_name": "Blue Jays",
          "right_short_name": "TOR",
          "left_name": "Dodgers",
          "left_short_name": "LAD",
          "left_image": "https://widgets-shared-static.stats.com/logos/40x40/baseball/mlb/243.png",
          "right_image": "https://widgets-shared-static.stats.com/logos/40x40/baseball/mlb/238.png",
          "period_title": "Finalizado",
          "score": "5 - 4",
          "liga": "Major League Baseball",
          "order_league": 1,
          "date": "1 de Nov",
          "current": false,
          "left_class": "clarosports-winner",
          "right_class": "clarosports-loser",
          "left_red_card": false,
          "right_red_card": false,
          "utc_date": "2025-11-02T00:00:00Z",
          "should_print_time": false,
          "sport": "BASE",
          "opta_event_url": "https://dev.clarosports.com/partido/?sport=baseball\u0026league=mlb\u0026eventId=2914252\u0026utm_id=2914252\u0026utm_campaign=home_hub_partido\u0026utm_content=dodgers_v_blue_jays",
          "venue_name": "Rogers Centre",
          "venue_state": "ON",
          "venue_country": "CAN",
          "left_score": "5",
          "right_score": "4",
          "race_results": {
            "laps": 0,
            "raceLength": "",
            "status": "",
            "podium": null,
            "circuit_image": "",
            "race_id": ""
          },
          "strendus_data": {
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": "",
            "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs\u0026utm_source=mc\u0026utm_medium=dp\u0026utm_campaign=mc_d_cpc_r_estadtcs"
          },
          "codere_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "caliente_metadata": {
            "event_id": "28287754",
            "left_url_mm": "https://online.caliente.mx/page?member=clarosports\u0026campaign=DEFAULT\u0026channel=DEFAULT\u0026zone=54300998\u0026lp=57942232\u0026BET_REF=MjQ0NTE5MzgxMjoyNy8yMDo6MA",
            "right_url_mm": "https://online.caliente.mx/page?member=clarosports\u0026campaign=DEFAULT\u0026channel=DEFAULT\u0026zone=54300998\u0026lp=57942232\u0026BET_REF=MjQ0NTE5MzgxMzo4LzE1Ojow",
            "middle_url_mm": "",
            "url_mm_evento": "https://online.caliente.mx/page?member=clarosports\u0026campaign=DEFAULT\u0026channel=DEFAULT\u0026zone=54300998\u0026lp=57943263\u0026ev_id=28287754",
            "left_mm": "+135",
            "right_mm": "-188",
            "middle_mm": ""
          },
          "streaming_data": {
            "has_streaming": false,
            "url": "",
            "provider": ""
          },
          "baseball_data": {
            "outs": 0,
            "strikes": 0,
            "onBase1": false,
            "onBase2": false,
            "onBase3": false,
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 5,
                "hits": 11,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "win",
                  "typeId": 2
                },
                "player": {
                  "playerId": 969448,
                  "firstName": "Yoshinobu",
                  "lastName": "Yamamoto",
                  "uniform": "18"
                },
                "wins": 3,
                "losses": 0,
                "earnedRunAverage": "1.02",
                "image": "https://widgets-shared-static.stats.com/headshots/48x48/baseball/mlb/969448.png"
              }
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 4,
                "hits": 14,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "lose",
                  "typeId": 3
                },
                "player": {
                  "playerId": 873698,
                  "firstName": "Shane",
                  "lastName": "Bieber",
                  "uniform": "57"
                },
                "wins": 1,
                "losses": 1,
                "earnedRunAverage": "2.84",
                "image": "https://widgets-shared-static.stats.com/headshots/48x48/baseball/mlb/873698.png"
              }
            }
          },
          "football_data": {
            "last_move": {
              "playerId": 0,
              "period": 0,
              "time": "",
              "down": "",
              "distance": "",
              "yardLine": "",
              "endYardLine": "",
              "driveId": 0,
              "startPossession": {
                "teamId": 0
              },
              "endPossession": {
                "teamId": 0
              }
            },
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            }
          },
          "basketball_data": {
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            }
          },
          "tenis_data": {
            "left_stats": {
              "left_seed": "",
              "first_server": false
            },
            "right_stats": {
              "right_seed": "",
              "first_server": false
            }
          }
        },
        {
          "id_juego": "2914252",
          "id_liga": "7",
          "id_torneo": "20252",
          "game_name": "Dodgers v Blue Jays",
          "class": "clarosports-next-game",
          "phase": "Postemporada",
          "right_name": "Blue Jays",
          "right_short_name": "TOR",
          "left_name": "Dodgers",
          "left_short_name": "LAD",
          "left_image": "https://widgets-shared-static.stats.com/logos/40x40/baseball/mlb/243.png",
          "right_image": "https://widgets-shared-static.stats.com/logos/40x40/baseball/mlb/238.png",
          "period_title": "Finalizado",
          "score": "5 - 4",
          "liga": "Major League Baseball",
          "order_league": 1,
          "date": "1 de Nov",
          "current": false,
          "left_class": "clarosports-winner",
          "right_class": "clarosports-loser",
          "left_red_card": false,
          "right_red_card": false,
          "utc_date": "2025-11-02T00:00:00Z",
          "should_print_time": false,
          "sport": "BASE",
          "opta_event_url": "https://dev.clarosports.com/partido/?sport=baseball\u0026league=mlb\u0026eventId=2914252\u0026utm_id=2914252\u0026utm_campaign=home_hub_partido\u0026utm_content=dodgers_v_blue_jays",
          "venue_name": "Rogers Centre",
          "venue_state": "ON",
          "venue_country": "CAN",
          "left_score": "5",
          "right_score": "4",
          "race_results": {
            "laps": 0,
            "raceLength": "",
            "status": "",
            "podium": null,
            "circuit_image": "",
            "race_id": ""
          },
          "strendus_data": {
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": "",
            "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs\u0026utm_source=mc\u0026utm_medium=dp\u0026utm_campaign=mc_d_cpc_r_estadtcs"
          },
          "codere_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "caliente_metadata": {
            "event_id": "28287754",
            "left_url_mm": "https://online.caliente.mx/page?member=clarosports\u0026campaign=DEFAULT\u0026channel=DEFAULT\u0026zone=54300998\u0026lp=57942232\u0026BET_REF=MjQ0NTE5MzgxMjoyNy8yMDo6MA",
            "right_url_mm": "https://online.caliente.mx/page?member=clarosports\u0026campaign=DEFAULT\u0026channel=DEFAULT\u0026zone=54300998\u0026lp=57942232\u0026BET_REF=MjQ0NTE5MzgxMzo4LzE1Ojow",
            "middle_url_mm": "",
            "url_mm_evento": "https://online.caliente.mx/page?member=clarosports\u0026campaign=DEFAULT\u0026channel=DEFAULT\u0026zone=54300998\u0026lp=57943263\u0026ev_id=28287754",
            "left_mm": "+135",
            "right_mm": "-188",
            "middle_mm": ""
          },
          "streaming_data": {
            "has_streaming": false,
            "url": "",
            "provider": ""
          },
          "baseball_data": {
            "outs": 0,
            "strikes": 0,
            "onBase1": false,
            "onBase2": false,
            "onBase3": false,
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 5,
                "hits": 11,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "win",
                  "typeId": 2
                },
                "player": {
                  "playerId": 969448,
                  "firstName": "Yoshinobu",
                  "lastName": "Yamamoto",
                  "uniform": "18"
                },
                "wins": 3,
                "losses": 0,
                "earnedRunAverage": "1.02",
                "image": "https://widgets-shared-static.stats.com/headshots/48x48/baseball/mlb/969448.png"
              }
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 4,
                "hits": 14,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "lose",
                  "typeId": 3
                },
                "player": {
                  "playerId": 873698,
                  "firstName": "Shane",
                  "lastName": "Bieber",
                  "uniform": "57"
                },
                "wins": 1,
                "losses": 1,
                "earnedRunAverage": "2.84",
                "image": "https://widgets-shared-static.stats.com/headshots/48x48/baseball/mlb/873698.png"
              }
            }
          },
          "football_data": {
            "last_move": {
              "playerId": 0,
              "period": 0,
              "time": "",
              "down": "",
              "distance": "",
              "yardLine": "",
              "endYardLine": "",
              "driveId": 0,
              "startPossession": {
                "teamId": 0
              },
              "endPossession": {
                "teamId": 0
              }
            },
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            }
          },
          "basketball_data": {
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            }
          },
          "tenis_data": {
            "left_stats": {
              "left_seed": "",
              "first_server": false
            },
            "right_stats": {
              "right_seed": "",
              "first_server": false
            }
          }
        },
        {
          "id_juego": "2914252",
          "id_liga": "7",
          "id_torneo": "20252",
          "game_name": "Dodgers v Blue Jays",
          "class": "clarosports-in-progress-game",
          "phase": "Postemporada",
          "right_name": "Blue Jays",
          "right_short_name": "TOR",
          "left_name": "Dodgers",
          "left_short_name": "LAD",
          "left_image": "https://widgets-shared-static.stats.com/logos/40x40/baseball/mlb/243.png",
          "right_image": "https://widgets-shared-static.stats.com/logos/40x40/baseball/mlb/238.png",
          "period_title": "50'",
          "score": "5 - 4",
          "liga": "Major League Baseball",
          "order_league": 1,
          "date": "1 de Nov",
          "current": false,
          "left_class": "clarosports-winner",
          "right_class": "clarosports-loser",
          "left_red_card": false,
          "right_red_card": false,
          "utc_date": "2025-11-02T00:00:00Z",
          "should_print_time": false,
          "sport": "BASE",
          "opta_event_url": "https://dev.clarosports.com/partido/?sport=baseball\u0026league=mlb\u0026eventId=2914252\u0026utm_id=2914252\u0026utm_campaign=home_hub_partido\u0026utm_content=dodgers_v_blue_jays",
          "venue_name": "Rogers Centre",
          "venue_state": "ON",
          "venue_country": "CAN",
          "left_score": "5",
          "right_score": "4",
          "race_results": {
            "laps": 0,
            "raceLength": "",
            "status": "",
            "podium": null,
            "circuit_image": "",
            "race_id": ""
          },
          "strendus_data": {
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": "",
            "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs\u0026utm_source=mc\u0026utm_medium=dp\u0026utm_campaign=mc_d_cpc_r_estadtcs"
          },
          "codere_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "caliente_metadata": {
            "event_id": "28287754",
            "left_url_mm": "https://online.caliente.mx/page?member=clarosports\u0026campaign=DEFAULT\u0026channel=DEFAULT\u0026zone=54300998\u0026lp=57942232\u0026BET_REF=MjQ0NTE5MzgxMjoyNy8yMDo6MA",
            "right_url_mm": "https://online.caliente.mx/page?member=clarosports\u0026campaign=DEFAULT\u0026channel=DEFAULT\u0026zone=54300998\u0026lp=57942232\u0026BET_REF=MjQ0NTE5MzgxMzo4LzE1Ojow",
            "middle_url_mm": "",
            "url_mm_evento": "https://online.caliente.mx/page?member=clarosports\u0026campaign=DEFAULT\u0026channel=DEFAULT\u0026zone=54300998\u0026lp=57943263\u0026ev_id=28287754",
            "left_mm": "+135",
            "right_mm": "-188",
            "middle_mm": ""
          },
          "streaming_data": {
            "has_streaming": false,
            "url": "",
            "provider": ""
          },
          "baseball_data": {
            "outs": 0,
            "strikes": 0,
            "onBase1": false,
            "onBase2": false,
            "onBase3": false,
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 5,
                "hits": 11,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "win",
                  "typeId": 2
                },
                "player": {
                  "playerId": 969448,
                  "firstName": "Yoshinobu",
                  "lastName": "Yamamoto",
                  "uniform": "18"
                },
                "wins": 3,
                "losses": 0,
                "earnedRunAverage": "1.02",
                "image": "https://widgets-shared-static.stats.com/headshots/48x48/baseball/mlb/969448.png"
              }
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 4,
                "hits": 14,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "lose",
                  "typeId": 3
                },
                "player": {
                  "playerId": 873698,
                  "firstName": "Shane",
                  "lastName": "Bieber",
                  "uniform": "57"
                },
                "wins": 1,
                "losses": 1,
                "earnedRunAverage": "2.84",
                "image": "https://widgets-shared-static.stats.com/headshots/48x48/baseball/mlb/873698.png"
              }
            }
          },
          "football_data": {
            "last_move": {
              "playerId": 0,
              "period": 0,
              "time": "",
              "down": "",
              "distance": "",
              "yardLine": "",
              "endYardLine": "",
              "driveId": 0,
              "startPossession": {
                "teamId": 0
              },
              "endPossession": {
                "teamId": 0
              }
            },
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            }
          },
          "basketball_data": {
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            }
          },
          "tenis_data": {
            "left_stats": {
              "left_seed": "",
              "first_server": false
            },
            "right_stats": {
              "right_seed": "",
              "first_server": false
            }
          }
        },
        {
          "id_juego": "2914252",
          "id_liga": "7",
          "id_torneo": "20252",
          "game_name": "Dodgers v Blue Jays",
          "class": "clarosports-error-game",
          "phase": "Postemporada",
          "right_name": "Blue Jays",
          "right_short_name": "TOR",
          "left_name": "Dodgers",
          "left_short_name": "LAD",
          "left_image": "https://widgets-shared-static.stats.com/logos/40x40/baseball/mlb/243.png",
          "right_image": "https://widgets-shared-static.stats.com/logos/40x40/baseball/mlb/238.png",
          "period_title": "Pospuesto",
          "score": "5 - 4",
          "liga": "Major League Baseball",
          "order_league": 1,
          "date": "1 de Nov",
          "current": false,
          "left_class": "clarosports-winner",
          "right_class": "clarosports-loser",
          "left_red_card": false,
          "right_red_card": false,
          "utc_date": "2025-11-02T00:00:00Z",
          "should_print_time": false,
          "sport": "BASE",
          "opta_event_url": "https://dev.clarosports.com/partido/?sport=baseball\u0026league=mlb\u0026eventId=2914252\u0026utm_id=2914252\u0026utm_campaign=home_hub_partido\u0026utm_content=dodgers_v_blue_jays",
          "venue_name": "Rogers Centre",
          "venue_state": "ON",
          "venue_country": "CAN",
          "left_score": "5",
          "right_score": "4",
          "race_results": {
            "laps": 0,
            "raceLength": "",
            "status": "",
            "podium": null,
            "circuit_image": "",
            "race_id": ""
          },
          "strendus_data": {
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": "",
            "strendus_default_event": "https://www.strendus.com.mx/deportes/#/?btag=mc_d_cpc_r_estadtcs\u0026utm_source=mc\u0026utm_medium=dp\u0026utm_campaign=mc_d_cpc_r_estadtcs"
          },
          "codere_metadata": {
            "event_id": "",
            "left_url_mm": "",
            "right_url_mm": "",
            "middle_url_mm": "",
            "url_mm_evento": "",
            "left_mm": "",
            "right_mm": "",
            "middle_mm": ""
          },
          "caliente_metadata": {
            "event_id": "28287754",
            "left_url_mm": "https://online.caliente.mx/page?member=clarosports\u0026campaign=DEFAULT\u0026channel=DEFAULT\u0026zone=54300998\u0026lp=57942232\u0026BET_REF=MjQ0NTE5MzgxMjoyNy8yMDo6MA",
            "right_url_mm": "https://online.caliente.mx/page?member=clarosports\u0026campaign=DEFAULT\u0026channel=DEFAULT\u0026zone=54300998\u0026lp=57942232\u0026BET_REF=MjQ0NTE5MzgxMzo4LzE1Ojow",
            "middle_url_mm": "",
            "url_mm_evento": "https://online.caliente.mx/page?member=clarosports\u0026campaign=DEFAULT\u0026channel=DEFAULT\u0026zone=54300998\u0026lp=57943263\u0026ev_id=28287754",
            "left_mm": "+135",
            "right_mm": "-188",
            "middle_mm": ""
          },
          "streaming_data": {
            "has_streaming": false,
            "url": "",
            "provider": ""
          },
          "baseball_data": {
            "outs": 0,
            "strikes": 0,
            "onBase1": false,
            "onBase2": false,
            "onBase3": false,
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 5,
                "hits": 11,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "win",
                  "typeId": 2
                },
                "player": {
                  "playerId": 969448,
                  "firstName": "Yoshinobu",
                  "lastName": "Yamamoto",
                  "uniform": "18"
                },
                "wins": 3,
                "losses": 0,
                "earnedRunAverage": "1.02",
                "image": "https://widgets-shared-static.stats.com/headshots/48x48/baseball/mlb/969448.png"
              }
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 4,
                "hits": 14,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "start_pitcher": {
                "type": {
                  "name": "lose",
                  "typeId": 3
                },
                "player": {
                  "playerId": 873698,
                  "firstName": "Shane",
                  "lastName": "Bieber",
                  "uniform": "57"
                },
                "wins": 1,
                "losses": 1,
                "earnedRunAverage": "2.84",
                "image": "https://widgets-shared-static.stats.com/headshots/48x48/baseball/mlb/873698.png"
              }
            }
          },
          "football_data": {
            "last_move": {
              "playerId": 0,
              "period": 0,
              "time": "",
              "down": "",
              "distance": "",
              "yardLine": "",
              "endYardLine": "",
              "driveId": 0,
              "startPossession": {
                "teamId": 0
              },
              "endPossession": {
                "teamId": 0
              }
            },
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescores": null,
              "has_possession": false
            }
          },
          "basketball_data": {
            "left_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            },
            "right_stats": {
              "record": {
                "wins": 0,
                "losses": 0,
                "ties": 0,
                "percentage": "",
                "winPercentage": ""
              },
              "linescoreTotals": {
                "runs": 0,
                "hits": 0,
                "errors": 0,
                "period": 0,
                "score": 0
              },
              "linescores": null
            }
          },
          "tenis_data": {
            "left_stats": {
              "left_seed": "",
              "first_server": false
            },
            "right_stats": {
              "right_seed": "",
              "first_server": false
            }
          }
        }
      ]
    }
  ]
}
/**
 * Determina la clase del patrocinador basada en el valor proporcionado
 * @param {string} patrocinador - Nombre del patrocinador
 * @returns {string} Clase CSS correspondiente al patrocinador
 */
export const getSponsorClass = (patrocinador) => {
  switch (patrocinador) {
    case 'caliente': return 'sponsor-caliente';
    case 'codere': return 'sponsor-codere';
    case 'strendus': return 'sponsor-strendus';
    default: return '';
  }
};